
import React, { useEffect, useState, useRef, useMemo } from 'react'; // Combined import statement
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
//import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import "../assets/css/background-colors.css";
import { Editcolor, Deletecolor, submit, Aprrovecolor, Rejectcolor, Retrievecolor, TableLoading, LoadingIcon } from './Propertyfile';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown, faListAlt, faFilter } from '@fortawesome/free-solid-svg-icons';



// ===========================================TableStructure====================================================

const getCssVariable = (variable) => {
  return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
};

const apiSessionId = sessionStorage.getItem("sessionId");

export const TableStyle = {
  maxHeight: 'calc(100vh - 265px)',
  overflowY: 'auto',
  overflowX: 'auto',
  marginTop: '10px',
};

export const TableStyle1 = {
  maxHeight: 'calc(100vh - 255px)',
  overflowY: 'auto',
  overflowX: 'auto',
  marginTop: '10px',
};

export const TableStyle2 = {
  maxHeight: 'calc(100vh - 255px)',
  overflowY: 'auto',
  overflowX: 'auto',
  marginTop: '0px',
};


export const TableStyle3 = {
  maxHeight: 'calc(100vh - 275px)',
  overflowY: 'auto',
  overflowX: 'auto',
  marginTop: '4px',
};

export const ListofTableFontsize = {
  fontSize: getCssVariable('--table-List-font-size')
};

export const EditIcon = {
  color: getCssVariable('--EditIconColor'),
  fontSize: getCssVariable('--Icon-Size')
};


export const DeleteIcon = {
  color: getCssVariable('--DeleteIconColor'),
  fontSize: getCssVariable('--Icon-Size')
};

export const ApporveIcon = {
  color: getCssVariable('--ApporveIcon'),
  fontSize: getCssVariable('--Icon-Size')
}

export const RejectIcon = {
  color: getCssVariable('--RejectIcon'),
  fontSize: getCssVariable('--Icon-Size')
}

export const tableClassStyle = {
  className: "table table-bordered table-hover table-shadow",
  style: {
    borderCollapse: 'collapse',
    width: '75%',
    margin: 'auto',
  },
};

export const tableClassStyleBDMDesignTable = {
  className: "table table-striped table-bordered table-hover",
  style: {
    borderCollapse: 'collapse',
    width: 'auto',
    margin: 'auto',
  },
};

export const TableHeader = {
  className: 'sticky-top',
  style: {
    zIndex: 1,
    top: '-1px',
    textAlign: 'center',
    // border: '1px solid black',
  },
  aliasNames: {
    col_name: 'COLUMN_NAME',
    col_type: 'COLUMN_TYPE',
    col_length: 'COLUMN_LENGTH',
    col_label: 'COLUMN_LABEL',
    col_key: 'COLUMN_KEY',
    col_rename: 'COLUMN_RENAME',
    col_active: 'COLUMN_ACTIVE',
    col_functions: 'COLUMN_FUNCTIONS',
  },
};


export const TableHeader1 = {
  zIndex: 1,                  // Z-index for stacking order
  top: '-1px',                // Top position
  textAlign: 'center',        // Text alignment in the header
  whiteSpace: 'nowrap',       // Prevents text from wrapping
  textWrap: 'nowrap',
  aliasNames: {
    col_name: 'COLUMN_NAME',
    col_type: 'COLUMN_TYPE',
    col_length: 'COLUMN_LENGTH',
    col_label: 'COLUMN_LABEL',
    col_key: 'COLUMN_KEY',
    col_rename: 'COLUMN_RENAME',
    col_active: 'COLUMN_INACTIVE',
    col_functions: 'COLUMN_FUNCTIONS',
  },
};
// =========================================================================================

export const tbodyStyles = {
  // border: '1px solid black',
  padding: '3px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const tbodyStyles1 = {
  // border: '1px solid black',
  padding: '0px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};


export const tbodyStyles2 = {
  padding: '0px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'center'
};

export const tableCellStyle = (index) => ({
  padding: '3px',
  fontSize: getCssVariable('--table-data-Font-Size'),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});


export const Tablecellsize = {
  fontSize: getCssVariable('--table-data-Font-Size'),
  // border: '1px solid black',
  padding: '5px',

  whiteSpace: 'nowrap'

};

export const tableCellStyle3 = (index) => ({
  padding: '3px',
  fontSize: getCssVariable('--table-data-Font-Size'),

  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const tableCellStyle4 = (index) => ({
  padding: '2px',

});
export const SummaryPagefontsize = {
  fontSize: getCssVariable('--Summary-report-font-size')
};

export const tableCellStyle1 = (rowIndex) => ({
  padding: '0px',
  fontSize: getCssVariable('--table-data-Font-Size'),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const tableCellStyle2 = (localRowIndex) => ({
  padding: '3px',
  fontSize: getCssVariable('--table-data-Font-Size'),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

// ============================================================================================================
// ============================ ----BRM --Master Data Backups---BackupcheckerList-==============================
// page :BackupcheckerList

export const BackupcheckerListTableStructure = ({
  tableName,
  backupTables,
  currentRecords,
  handleApprove,
  handleReject,
  previewRedirect,
  approveButtonStyle,
  rejectButtonStyle,
  previewButtonStyle,
  totalPages,
  currentPage,
  paginate,
}) => {
  return (
    <main className="col-md-9 ms-sm-auto col-lg-12 px-md-4">
      <div className="text-center">
        <h4>{tableName.charAt(0).toUpperCase() + tableName.slice(1)}</h4>

        {(backupTables === null || backupTables.length === 0) ? (
          <p className="text-center">Nothing Pending for Review</p>
        ) : (
          <div
            style={{
              maxHeight: 'calc(100vh - 250px)',
              overflowY: 'auto',
              overflowX: 'auto',
              marginTop: '10px',
            }}
          >
            <table
              className={tableClassStyle.className}
              style={tableClassStyle.style}
            >
              <thead
                className={TableHeader.className}
                style={
                  TableHeader.style
                }
              >
                <tr>
                  <th className="text-center" style={TableHeader.style}>
                    TableName
                  </th>
                  <th className="text-center" style={TableHeader.style}>
                    BackupDate
                  </th>
                  <th className="text-center" style={TableHeader.style}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody
                style={

                  tbodyStyles
                }
              >
                {currentRecords.map((table, index) => (
                  <tr key={index}>
                    <td
                      style={
                        tableCellStyle(index)
                      }
                    >
                      {table.tableName.split('_')[0].charAt(0).toUpperCase() +
                        table.tableName.split('_')[0].slice(1)}
                    </td>
                    <td
                      style={
                        tableCellStyle(index)
                      }
                    >
                      {table.backupDate}
                    </td>
                    <td
                      style={
                        tableCellStyle(index)
                      }
                    >
                      <button
                        type="button"
                        className="btn btn-light btn-sm "
                        data-toggle="tooltip"
                        data-placement="Left"
                        title="Click to Approve"
                        style={{
                          marginLeft: '15px',
                          border: 'none',
                          backgroundColor: 'transparent',
                        }}
                        onClick={() => handleApprove(table.tableName)}
                      >
                        {/* Icon with green fill and white border */}
                        <link
                          href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                          rel="stylesheet"
                        />
                        <i
                          className="bi bi-check-circle"
                          style={{
                            ...ApporveIcon,
                            marginRight: '10px'
                          }}
                        ></i>
                      </button>

                      <button
                        type="button"
                        // className="btn btn-light btn-sm"
                        className="btn btn-light btn-sm"

                        data-toggle="tooltip"
                        data-placement="Left"
                        title="Click to Reject"
                        style={{
                          border: 'none',            // No border for the button
                          backgroundColor: 'transparent', // Transparent background for the button
                        }}
                        onClick={() => handleReject(table.tableName)}
                      >
                        <i
                          className="bi bi-x-circle"
                          style={{
                            ...RejectIcon,
                            marginRight: '5px',
                            // Icon size


                          }}
                        ></i>
                      </button>
                      <button
                        type="button"
                        // className="btn btn-light btn-sm"
                        className="btn btn-light btn-sm"

                        data-toggle="tooltip"
                        data-placement="Left"
                        title="Click to Preview"
                        style={{

                          border: 'none',            // No border for the button
                          backgroundColor: 'transparent', // Transparent background for the button
                        }}
                        onClick={() => previewRedirect(table.tableName)}
                      >

                        <i
                          className="bi bi-eye-fill"
                          style={{

                            marginRight: '5px',
                            // Icon size,
                            lineHeight: '10px',
                            ...ApporveIcon


                          }}
                        ></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />
    </main>
  );
};


export const BDMDEMBackupcheckerList = ({ tableName, backupTables, currentRecords, handleApprove, handleReject, previewRedirect, approveButtonStyle, rejectButtonStyle, previewButtonStyle }) => {
  return (
    <div className="text-center">
      {/* <h4>
        {tableName.split('_')[0].charAt(0).toUpperCase() + tableName.split('_')[0].slice(1)}
      </h4> */}
      <h4 >
        {tableName
          .replace(/_temp_backup_\d+$/, '') // Remove "_temp_backup_" followed by digits at the end
          .replace(/_/g, ' ') // Replace underscores with spaces
          .split(' ') // Split by spaces
          .map((word) =>
            word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize each word
          )
          .join(' ')} {/* Join the words back with spaces */}
      </h4>

      {(backupTables === null || backupTables.length === 0) ? (
        <p className="text-center">Nothing Pending for Review</p>
      ) : (
        <div style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto', overflowX: 'auto', marginTop: '10px' }}>
          <table className="table table-striped table-bordered table-hover" style={{ borderCollapse: 'collapse', width: '70%', margin: 'auto' }}>
            <thead className='sticky-top'
              style={
                // { backgroundColor: '#ffffff', zIndex: 1, top: '-1px', textAlign: 'center', border: '1px solid black' }
                TableHeader1
              }>
              <tr>
                <th className="text-center" style={TableHeader1}>TableName</th>
                <th className="text-center" style={TableHeader1}>BackupDate</th>
                <th className="text-center" style={TableHeader1}>Actions</th>
              </tr>
            </thead>
            <tbody style={
              // { border: '1px solid black', padding: '5px', fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
              tbodyStyles
            }>
              {currentRecords.map((table, index) => (
                <tr key={index}>
                  <td
                    style={

                      tableCellStyle(index)
                    }>
                    {/* {table.tableName.split('_')[0].charAt(0).toUpperCase() + table.tableName.split('_')[0].slice(1)} */}
                    {tableName
                      .replace(/_temp_backup_\d+$/, '') // Remove "_temp_backup_" followed by digits at the end
                      .replace(/_/g, ' ') // Replace underscores with spaces
                      .split(' ') // Split by spaces
                      .map((word) =>
                        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize each word
                      )
                      .join(' ')} {/* Join the words back with spaces */}
                  </td>
                  <td
                    style=
                    {

                      tableCellStyle(index)
                    }>
                    {table.backupDate}
                  </td>
                  <td style={

                    tableCellStyle(index)
                  }>

                    <button
                      type="button"
                      className="btn btn-light btn-sm "
                      data-toggle="tooltip"
                      data-placement="Left"
                      title="Click to Approve"
                      style={{
                        marginLeft: '15px',
                        border: 'none',
                        backgroundColor: 'transparent',
                      }}
                      onClick={() => handleApprove(table.tableName)}
                    >
                      <link
                        href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                        rel="stylesheet"
                      />
                      <i
                        className="bi bi-check-circle"
                        style={{
                          ...ApporveIcon,
                          marginRight: '10px'
                        }}
                      ></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-light btn-sm"

                      data-toggle="tooltip"
                      data-placement="Left"
                      title="Click to Reject"
                      style={{
                        border: 'none',            // No border for the button
                        backgroundColor: 'transparent', // Transparent background for the button
                      }}
                      onClick={() => handleReject(table.tableName)}
                    >

                      <i
                        className="bi bi-x-circle"
                        style={{

                          ...RejectIcon,
                          marginRight: '5px',
                        }}
                      ></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-light btn-sm"

                      data-toggle="tooltip"
                      data-placement="Left"
                      title="Click to Preview"
                      style={{
                        border: 'none',            // No border for the button
                        backgroundColor: 'transparent', // Transparent background for the button
                      }}
                      onClick={() => previewRedirect(table.tableName)}
                    >

                      <i
                        className="bi bi-eye-fill"
                        style={{

                          marginRight: '5px',
                          // Icon size,
                          lineHeight: '10px',
                          ...ApporveIcon

                        }}
                      ></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};


// =========================================Backup preview Checker ================================

// DEMcheckerPreview,BDMcheckerPreview

export const BackupPreviewChecker = ({ loading, error, tableData, currentRecords }) => {
  return (
    <div className="col-md-9 ms-sm-auto col-lg-12 px-md-4">
      <div className="text-center">
        {loading ? (
          <div className="spinner-border text-dark" role="status" style={{ marginLeft: '10px' }}>
            {/* <span className="visually-hidden">Loading...</span> */}
            <TableLoading />
          </div>

        ) : error ? (
          <p className="text-center">{error}</p>
        ) : tableData.length === 0 ? (
          <p>Nothing Pending for Preview</p>
        ) : (
          <div
            style={{
              maxHeight: 'calc(100vh - 250px)',
              overflowY: 'auto',
              overflowX: 'auto',
              marginTop: '10px',
            }}
          >
            <table
              className={tableClassStyle.className}
              style={
                tableClassStyle.style
              }
            >
              <thead
                className="sticky-top"
                style={
                  TableHeader1
                }
              >
                <tr>
                  {Object.keys(tableData[0])
                    .filter(
                      (key) =>
                        ![
                          'rowId',
                          'created_dt',
                          'created_by',
                          'modified_dt',
                          'modified_by',
                          'approved_by',
                          'approved_dt',
                        ].includes(key)
                    )
                    .map((header) => (
                      <th
                        className="text-center"
                        style={
                          TableHeader1
                        }
                        key={header}
                      >
                        {header}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody
                style={
                  tbodyStyles
                }
              >
                {currentRecords.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {Object.keys(row)
                      .filter(
                        (key) =>
                          ![
                            'rowId',
                            'created_dt',
                            'created_by',
                            'modified_dt',
                            'modified_by',
                            'approved_by',
                            'approved_dt',
                          ].includes(key)
                      )
                      .map((header) => (
                        <td
                          style={

                            tableCellStyle3(rowIndex)
                          }
                          key={header}
                        >
                          {row[header]}
                        </td>
                      ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export const BackUpDEMBDMPreviewTable = ({ Loading, error, tableData, currentRecords }) => {
  return (
    <div className="col-md-9 ms-sm-auto col-lg-12 px-md-4">
      <div className="text-center">
        {Loading ? (
          <div className="spinner-border text-dark" role="status" style={{ marginLeft: '10px' }}>
            <TableLoading />
          </div>
        ) : error ? (
          <p className="text-center">{error}</p>
        ) : tableData.length === 0 ? (
          <p>Nothing Pending for Preview</p>
        ) : (
          <div
            style={{
              maxHeight: 'calc(100vh - 250px)',
              overflowY: 'auto',
              overflowX: 'auto',
              marginTop: '10px',
            }}
          >
            <table
              className={tableClassStyle.className}
              style={

                tableClassStyle.style
              }
            >
              <thead
                className="sticky-top"
                style={

                  TableHeader1
                }
              >
                <tr>
                  {Object.keys(tableData[0])
                    .filter(
                      (key) =>
                        ![
                          'rowId',
                          'created_dt',
                          'created_by',
                          'modified_dt',
                          'modified_by',
                          'approved_by',
                          'approved_dt',
                          'id',
                          'table_name',
                        ].includes(key)
                    )

                    .map((header) => (
                      <th
                        className="text-center"
                        style={
                          {
                            border: '1px solid black',
                            padding: '5px',
                          }

                        }
                        key={header}
                      >
                        {header}
                      </th>
                    ))}
                </tr>
              </thead>
              <tbody
                style={
                  {

                    tbodyStyles
                  }
                }
              >
                {currentRecords.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {Object.keys(row)
                      .filter(
                        (key) =>
                          ![
                            'rowId',
                            'created_dt',
                            'created_by',
                            'modified_dt',
                            'modified_by',
                            'approved_by',
                            'approved_dt',
                            'id',
                            'table_name',
                          ].includes(key)
                      )
                      .map((header) => (
                        <td
                          style={

                            tableCellStyle3(rowIndex)
                          }
                          key={header}
                        >
                          {row[header]}
                        </td>
                      ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};


export const BackUpListTableComponent = ({
  tableName,
  isLoading,
  backupTables,
  currentRecords,
  RestoreButtonStyle,
  previewButtonStyle,
  handleShowModal,
  previewRedirect,
  totalPages,
  currentPage,
  paginate
}) => {
  return (
    <main className="col-md-9 ms-sm-auto col-lg-12 px-md-4">
      <div className="text-center">
        <h4>
          {tableName.charAt(0).toUpperCase() + tableName.slice(1)}
        </h4>

        {isLoading && (
          <div className="spinner-border text-dark" role="status" style={{ marginLeft: '10px' }}>
            <TableLoading />

          </div>
        )}

        {!isLoading && backupTables.length === 0 ? (
          <p className="text-center">Nothing Pending for Restore</p>
        ) : (
          !isLoading && (
            <div style={{ maxHeight: 'calc(102vh - 260px)', overflowY: 'auto', overflowX: 'auto', marginTop: '10px' }}>
              <table className={tableClassStyle.className}
                style={
                  // { borderCollapse: 'collapse', width: '70%', margin: 'auto' }
                  tableClassStyle.style
                }>
                <thead className="sticky-top" style={
                  // { backgroundColor: '#ffffff', zIndex: 1, top: '-1px', textAlign: 'center', border: '1px solid black' }
                  TableHeader1
                }>
                  <tr>
                    <th className="text-center"
                      style={
                        // { border: '1px solid black', padding: '5px' }
                        TableHeader1
                      }>TableName</th>
                    <th className="text-center" style={TableHeader1}>BackupDate</th>
                    <th className="text-center" style={TableHeader1}>Actions</th>
                  </tr>
                </thead>
                <tbody style={
                  // { border: '1px solid black', padding: '5px', fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
                  tbodyStyles
                }>
                  {currentRecords.map((table, index) => (
                    <tr key={index} style={{ lineHeight: '25px' }}>
                      <td style={

                        tableCellStyle(index)
                      }>
                        {table.tableName.split('_')[0].charAt(0).toUpperCase() + table.tableName.split('_')[0].slice(1)}
                      </td>
                      <td style={

                        tableCellStyle(index)
                      }>
                        {table.backupDate}
                      </td>
                      <td style={

                        tableCellStyle(index)
                      }>

                        <button
                          type="button"
                          className="btn btn-light btn-sm "
                          data-toggle="tooltip"
                          data-placement="Left"
                          title="Click to Restore"
                          style={{
                            marginLeft: '15px',
                            border: 'none',
                            backgroundColor: 'transparent',
                          }}
                          onClick={() => handleShowModal(table.tableName)}
                        >
                          <link
                            href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                            rel="stylesheet"
                          />
                          <i
                            className="bi bi-arrow-repeat"
                            style={{
                              ...ApporveIcon,
                              marginRight: '10px',
                              lineHeight: '7px'
                            }}
                          ></i>
                        </button>

                        <button
                          type="button"
                          className="btn btn-light btn-sm"

                          data-toggle="tooltip"
                          data-placement="Left"
                          title="Click to Preview"
                          style={{
                            border: 'none',            // No border for the button
                            backgroundColor: 'transparent', // Transparent background for the button
                          }}
                          onClick={() => previewRedirect(table.tableName)}
                        >

                          <i
                            className="bi bi-eye-fill"
                            style={{
                              ...ApporveIcon,
                              marginRight: '5px',
                              // Icon size,
                              lineHeight: '5px',


                            }}
                          ></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        )}
        <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />
      </div>
    </main>
  );
};

// ==================================================================================================

// =====================================User.Js Paginations ==========================================


export const UsersPagination = ({
  currentPage,
  itemsPerPage,
  totalItems,
  onPageChange,
}) => {
  if (totalItems <= itemsPerPage) return null;

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const maxVisiblePages = 4; // Number of visible pages at a time

  // Helper function to generate page numbers and ellipses
  const getPageNumbers = () => {
    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Show all pages if total pages are less than or equal to maxVisiblePages
      pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    } else {
      // Calculate range of pages to display
      const halfRange = Math.floor(maxVisiblePages / 2);
      let startPage = currentPage - halfRange;
      let endPage = currentPage + halfRange;

      // Adjust start and end if they are out of bounds
      if (startPage <= 1) {
        startPage = 1;
        endPage = maxVisiblePages;
      }
      if (endPage >= totalPages) {
        endPage = totalPages;
        startPage = totalPages - maxVisiblePages + 1;
        if (startPage < 1) startPage = 1; // Ensure startPage is not less than 1
      }

      pages = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

      // Add ellipses
      if (startPage > 1) {
        pages = [1, '...', ...pages];
      }
      if (endPage < totalPages) {
        pages = [...pages, '...', totalPages];
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="table-on-homepage-only">
      <div className="d-flex justify-content-center align-items-center mt-half pagination-container">
        <div
          className="rounded-pill shadow-sm px-2 py-0 d-flex align-items-center gap-1"
          style={{
            fontSize: '0.8rem',
            border: '1px solid #366872',
          }}
        >

          {/* Previous button */}
          <button
            className={`btn btn-light btn-sm pagination-btn ${currentPage === 1 ? 'disabled' : ''}`}
            style={{ padding: '2px 8px' }}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            &lt;
          </button>

          {/* Render page numbers and ellipses */}
          {pageNumbers.map((page, index) => (
            page === '...' ? (
              <span key={`ellipsis-${index}`} className="text-muted px-1">...</span>
            ) : (
              <button
                className={`btn btn-sm pagination-btn ${currentPage === page ? 'active' : ''}`}
                onClick={() => onPageChange(page)}
                style={{ padding: '2px 8px', minWidth: '30px' }}
              >
                {page}
              </button>
            )
          ))}

          {/* Next button */}
          <button
            className={`btn btn-light btn-sm pagination-btn ${currentPage === totalPages ? 'disabled' : ''}`}
            style={{ padding: '2px 8px' }}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            &gt;
          </button>
        </div>
      </div>
    </div>
  );
};

export const TableTemplateListGapsy = ({
  currentRecords,
  ListofTableFontsize,
  handleTableClick,
  currentPage,
  recordsPerPage
}) => {
  const [selectedTable, setSelectedTable] = useState(null);

  const formatTableName = (name) => {
    const nameParts = name.split('_');
    nameParts.shift();
    return nameParts
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const handleCheckboxChange = (tableName) => {
    const isAlreadySelected = selectedTable === tableName;
    const newSelection = isAlreadySelected ? null : tableName;

    setSelectedTable(newSelection);

    if (!isAlreadySelected) {
      handleTableClick(tableName); // Simulates "+ Add Data"
    } else {
      handleTableClick(null); // Optional: Clear selection behavior
    }
  };

  return (
    <div className="table-on-homepage-only">
      <table className="table table-bordered m-auto table-shadow mt-2">
        <thead>
          <tr>
            {/* <th scope="col" >S.No.</th> */}
            <th scope="col" className="col-1 text-center">S.No.</th>
            <th scope="col">List of Templates</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.length === 0 ? (
            <tr>
              <td colSpan="2" className="text-center">No Table found.</td>
            </tr>
          ) : (
            currentRecords.map((item, index) => {
              const serialNumber = (currentPage - 1) * recordsPerPage + index + 1;
              const formattedName = formatTableName(item);
              const isSelected = selectedTable === item;

              return (
                <tr key={index} className={selectedTable === item ? 'table-active' : ''}>
                  <td className="py-1 align-middle">{serialNumber}</td>
                  <td className="py-1 px-0 align-middle" style={ListofTableFontsize}>
                    <div className="form-check px-2">
                      <input
                        className="form-check-input d-none"
                        type="checkbox"
                        id={`checkbox-${index}`}
                        checked={selectedTable === item}
                        onChange={() => handleCheckboxChange(item)}
                      />
                      <label htmlFor={`checkbox-${index}`} className='mt-1 px-0'>
                        {formattedName}
                      </label>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export const TableRetrievalListGapsy = ({
  currentRecords,
  ListofTableFontsize,
  handleTableClick,
  currentPage,
  recordsPerPage,
  showPastTablesOnly,
  handleTogglePastTables,
  selectedTableName
}) => {
  const [selectedTable, setSelectedTable] = useState(null);

  const formatTableName = (name) => {
    const nameParts = name.split('_');
    nameParts.shift();
    return nameParts
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };
  const handleCheckboxChange = (tableName, isPast) => {
    const isAlreadySelected = selectedTableName === tableName;

    if (!isAlreadySelected) {
      handleTableClick({ name: tableName, isPast });
    } else {
      // Deselect logic: Only if you want to support unchecking
      handleTableClick(null);
    }
  };


  return (
    <div className="table-on-homepage-only">
      <table className="table table-bordered m-auto table-shadow mt-2">
        <thead>
          <tr>
            <th scope="col" className="col-1 text-center">S.No.</th>

            <th scope="col">
              <div className="d-flex justify-content-between align-items-center">
                <span>List of Templates</span>
                <span className="d-flex align-items-center ms-2 mb-0" htmlFor="retrieved-toggle">
                  <input
                    className="form-check-input me-1"
                    type="checkbox"
                    id="retrieved-toggle"
                    checked={showPastTablesOnly}
                    onChange={handleTogglePastTables}
                  />
                  <span className="mb-0 fst-italic fw-normal" style={{ fontSize: '11px' }}>
                    (Select to view Rejected past data)
                  </span>
                </span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.length === 0 ? (
            <tr>
              <td colSpan="2" className="text-center">No Table found.</td>
            </tr>
          ) : (
            currentRecords.map((item, index) => {
              const serialNumber = (currentPage - 1) * recordsPerPage + index + 1;
              const formattedName = formatTableName(item.name);
              // const isSelected = selectedTable === item.name;
              const isSelected = selectedTableName === item.name;


              return (
                <tr key={index} className={isSelected ? 'table-active' : ''}>
                  <td className="py-1 align-middle">{serialNumber}</td>
                  <td className="py-1 px-0 align-middle" style={ListofTableFontsize}>
                    <div className="form-check px-2">
                      <input
                        className="form-check-input d-none"
                        type="checkbox"
                        id={`checkbox-${index}`}
                        checked={isSelected}
                        onChange={() => handleCheckboxChange(item.name, item.isPast)}
                      />
                      <label htmlFor={`checkbox-${index}`} className='mt-1 px-0'>
                        {formattedName}
                      </label>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};


export const TableListGapsy = ({
  currentRecords,
  ListofTableFontsize,
  handleTableClick,
  currentPage,
  recordsPerPage,
  showOnlyRetrieved,
  handleRetrievedToggle,
  searchQuery
}) => {
  const [selectedTable, setSelectedTable] = useState(null);

  const formatTableName = (name) => {
    const nameParts = name.split('_');
    nameParts.shift();
    return nameParts
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const filteredAndPaginated = useMemo(() => {
    const query = (searchQuery || "").toLowerCase().trim();

    const filtered = currentRecords.filter((item) => {
      const fullTableName = Object.keys(item)[0];
      return fullTableName.toLowerCase().includes(query);
    });

    const indexOfLast = currentPage * recordsPerPage;
    const indexOfFirst = indexOfLast - recordsPerPage;

    return filtered.slice(indexOfFirst, indexOfLast);
  }, [currentRecords, searchQuery, currentPage, recordsPerPage]);


  const handleCheckboxChange = (tableName) => {
    const isAlreadySelected = selectedTable === tableName;
    const newSelection = isAlreadySelected ? null : tableName;

    setSelectedTable(newSelection);

    if (!isAlreadySelected) {
      handleTableClick(tableName); // Simulates "+ Add Data"
    } else {
      handleTableClick(null); // Optional: Clear selection behavior
    }
  };

  return (
    <div className="table-on-homepage-only">
      <table className="table table-bordered m-auto table-shadow mt-2">
        <thead>
          <tr>
            <th scope="col" className="col-1 text-center">S.No.</th>
            <th scope="col">
              <div className="d-flex justify-content-between align-items-center">
                <span>List of Templates</span>
                <span className="d-flex align-items-center ms-2 mb-0" htmlFor="retrieved-toggle">
                  <input
                    className="form-check-input me-1"
                    type="checkbox"
                    id="retrieved-toggle"
                    checked={showOnlyRetrieved}
                    onChange={(e) => handleRetrievedToggle(e.target.checked)}
                  />
                  <span className="mb-0 fst-italic fw-normal" style={{ fontSize: '11px' }}>
                    (Select to view Modified past data)
                  </span>
                </span>
              </div>
            </th>

          </tr>
        </thead>

        <tbody>
          {filteredAndPaginated.length === 0 ? (
            <tr>
              <td colSpan="2" className="text-center">Choose a Department</td>
            </tr>
          ) : (
            filteredAndPaginated.map((item, index) => {
              const fullTableName = Object.keys(item)[0]; // e.g., "finance_glcode"
              const serialNumber = (currentPage - 1) * recordsPerPage + index + 1;
              const formattedName = formatTableName(fullTableName);

              return (
                <tr key={index}>
                  <td className="py-1">{serialNumber}</td>
                  <td className="py-1" style={ListofTableFontsize}>
                    <div className="form-check">
                      <input
                        className="form-check-input d-none"
                        type="checkbox"
                        id={`checkbox-${index}`}
                        checked={selectedTable === fullTableName}
                        onChange={() => handleCheckboxChange(fullTableName)}
                      />
                      <label htmlFor={`checkbox-${index}`}>
                        {formattedName}
                      </label>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export const TemplateListGapsy = ({
  currentRecords,
  ListofTableFontsize,
  handleTableClick,
  currentPage,
  recordsPerPage,
  loading
}) => {
  const [selectedTable, setSelectedTable] = useState(null);

  const formatTableName = (name) => {
    const nameParts = name.split('_');
    nameParts.shift(); // Remove the prefix
    return nameParts
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const handleCheckboxChange = (tableKey) => {
    const isAlreadySelected = selectedTable === tableKey;
    const newSelection = isAlreadySelected ? null : tableKey;

    setSelectedTable(newSelection);
    handleTableClick(isAlreadySelected ? null : tableKey);
  };

  return (
    <div className="table-on-homepage-only">
      <table className="table table-bordered m-auto table-shadow mt-2">
        <thead>
          <tr>
            <th className="col-1 text-center">S.No.</th>
            <th>List of Templates</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="2" className="text-center py-3">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          ) : currentRecords.length === 0 ? (
            <tr>
              <td colSpan="2" className="text-center">No Table found.</td>
            </tr>
          ) : (
            currentRecords.map((item, index) => {
              const tableKey = Object.keys(item)[0];
              const serialNumber = (currentPage - 1) * recordsPerPage + index + 1;
              const formattedName = formatTableName(tableKey);

              return (
                <tr key={index}>
                  <td className="py-1 text-center">{serialNumber}</td>
                  <td className="py-1" style={ListofTableFontsize}>
                    <div className="form-check">
                      <input
                        className="form-check-input d-none"
                        type="checkbox"
                        id={`checkbox-${index}`}
                        checked={selectedTable === tableKey}
                        onChange={() => handleCheckboxChange(tableKey)}
                      />
                      <label htmlFor={`checkbox-${index}`}>
                        {formattedName}
                      </label>
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};



export const DepartmentDropdown = ({ selectedPrefix, setSelectedPrefix, prefixes }) => {
  return (
    <div className="dropdown">
      <button
        className="btn btn-light btn-sm dropdown-toggle dropdown-button-color text-nowrap"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {selectedPrefix || "Select Department"}
      </button>
      <ul
        className="dropdown-menu mt-1"
        aria-labelledby="dropdownMenuButton"
        style={{ maxHeight: '200px', overflowY: 'auto' }}
      >
        {prefixes.map((prefix, idx) => (
          <li key={idx}>
            <a
              className="dropdown-item"
              href="#"
              onClick={(e) => {
                e.preventDefault(); // prevent page jump
                setSelectedPrefix(prefix);
              }}
            >
              {prefix}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};


export const TableTemplateList = ({
  currentRecords,
  ListofTableFontsize,
  handleTableClick,
  currentPage,
  recordsPerPage
}) => {
  const formatTableName = (name) => {
    const nameParts = name.split('_');
    // Remove the prefix (first part)
    nameParts.shift();
    return nameParts
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <table className="table table-bordered m-auto table-shadow mt-2">
      <thead>
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Table Name</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        {currentRecords.length === 0 ? (
          <tr>
            <td colSpan="3" className="text-center">No Table found.</td>
          </tr>
        ) : (
          currentRecords.map((item, index) => {
            // Calculate the serial number based on the current page and the index
            const serialNumber = (currentPage - 1) * recordsPerPage + index + 1;
            return (
              <tr key={index}>
                <td>{serialNumber}</td> {/* Display the calculated serial number */}
                <td style={ListofTableFontsize}>{formatTableName(item)}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-AddData rounded-0"
                    onClick={() => handleTableClick(item)}
                  >
                    + Add Data
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};

export const TableTemplateList1 = ({
  currentRecords,
  ListofTableFontsize,
  handleTableClick,
  currentPage,
  recordsPerPage
}) => {
  const formatTableName = (name) => {
    const nameParts = name.split('_');
    // Remove the prefix (first part)
    nameParts.shift();
    return nameParts
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <table className="table table-bordered m-auto table-shadow mt-2">
      <thead>
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Table Name</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        {currentRecords.length === 0 ? (
          <tr>
            <td colSpan="3" className="text-center">No Table found.</td>
          </tr>
        ) : (
          currentRecords.map((item, index) => {
            // Calculate the serial number based on the current page and the index
            const serialNumber = (currentPage - 1) * recordsPerPage + index + 1;
            return (
              <tr key={index}>
                <td>{serialNumber}</td> {/* Display the calculated serial number */}
                <td style={ListofTableFontsize}>{formatTableName(item)}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-AddData rounded-0"
                    onClick={() => handleTableClick(item)}
                  >
                    Modify
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};

export const TableTemplateList2 = ({
  currentRecords,
  ListofTableFontsize,
  handleTableClick,
  currentPage,
  recordsPerPage
}) => {
  const formatTableName = (name) => {
    const nameParts = name.split('_');
    // Remove the prefix (first part)
    nameParts.shift();
    return nameParts
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <table className="table table-bordered m-auto table-shadow mt-2">
      <thead>
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Table Name</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        {currentRecords.length === 0 ? (
          <tr>
            <td colSpan="3" className="text-center">No Table found.</td>
          </tr>
        ) : (
          currentRecords.map((item, index) => {
            // Calculate the serial number based on the current page and the index
            const serialNumber = (currentPage - 1) * recordsPerPage + index + 1;
            return (
              <tr key={index}>
                <td>{serialNumber}</td> {/* Display the calculated serial number */}
                <td style={ListofTableFontsize}>{formatTableName(item)}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-AddData rounded-0"
                    onClick={() => handleTableClick(item)}
                  >
                    Review
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};

export const ApproveTableTemplateList = ({ currentRecords, ListofTableFontsize, handleTableClick, currentPage, recordsPerPage }) => {
  const formatTableName = (name) => {
    return name
      .replace(/_/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <table className="table table-bordered m-auto table-shadow">
      <thead>
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Table Name</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        {currentRecords.length === 0 ? (
          <tr>
            <td colSpan="3" className="text-center">No Table found.</td>
          </tr>
        ) : (
          currentRecords.map((item, index) => {
            // Calculate the serial number based on the page and index
            const serialNumber = (currentPage - 1) * recordsPerPage + index + 1;
            return (
              <tr key={index}>
                <td>{serialNumber}</td> {/* Display the calculated serial number */}
                <td style={ListofTableFontsize}>{formatTableName(item)}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-sm btn-AddData rounded-0"
                    onClick={() => handleTableClick(item)}
                  >
                    Modify
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};

export const ModifyTemplateList = ({
  allRecords,
  recordsPerPage,
  ListofTableFontsize,
  handleTableClick,
  departmentList,
  handleDepartmentSelect
}) => {
  const [prefixes, setPrefixes] = useState([]);
  const [selectedPrefix, setSelectedPrefix] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [modalMessageOne, setModalMessageOne] = useState(""); // For modal messages

  // Format the table names nicely
  const formatTableName = (name) => {
    if (!name || typeof name !== 'string') return '';
    return name
      .replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  // Filtering logic based on search query
  const filteredRecordsMemo = useMemo(() => {
    const recordsToFilter = selectedPrefix
      ? allRecords.filter(item => item.fullName.startsWith(selectedPrefix))
      : allRecords;

    return recordsToFilter.filter((tableName) => {
      const recordName = tableName?.displayName?.toLowerCase().trim() || "";
      const query = searchQuery.toLowerCase().trim();
      return recordName.includes(query);
    });
  }, [allRecords, selectedPrefix, searchQuery]);


  // Reset current page when search query changes
  useEffect(() => {
    setCurrentPage(1); // Reset to the first page when filtering
  }, [searchQuery]);

  // Calculate total pages based on filtered records
  const totalPages = Math.ceil(filteredRecordsMemo.length / recordsPerPage);

  // Calculate current records to display based on pagination
  const currentRecords = useMemo(() => {
    const startIndex = (currentPage - 1) * recordsPerPage;
    return filteredRecordsMemo.slice(startIndex, startIndex + recordsPerPage);
  }, [filteredRecordsMemo, currentPage, recordsPerPage]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.trimStart()); // Remove leading spaces
  };

  const handleModalClose = () => {
    setModalMessageOne("");  // Clear modal message to close it
  };

  // Fetch data for the records based on selected prefix
  useEffect(() => {
    if (Array.isArray(departmentList) && departmentList.length > 0) {
      setPrefixes(departmentList);  // Use actual department names from API
    }
  }, [departmentList]);

  const handleDepartmentChange = (dept) => {
    setSelectedPrefix(dept);
    handleDepartmentSelect(dept);  // Notify parent to refetch based on department
  };

  return (
    <>
      <div className="row">
        <div className="col-md-10">
          {/* Department Dropdown & Search Input on Same Line */}
          <div className="d-flex align-items-center gap-3 mb-3">
            {prefixes.length > 0 && (
              <div className="dropdown">
                <button
                  className="btn btn-light dropdown-toggle dropdown-button-color"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {selectedPrefix || "Select Department"}
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="dropdownMenuButton"
                  style={{ maxHeight: '200px', overflowY: 'auto', marginTop: '2px' }}
                >
                  {departmentList.map((dept, idx) => (
                    <li key={idx}>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => handleDepartmentChange(dept)}
                      >
                        {dept}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Search Input (only shown if department is selected) */}
            {selectedPrefix && (
              <input
                type="text"
                className="form-control mt-n1"
                placeholder="Search templates..."
                value={searchQuery}
                style={{ width: "210px" }}
                onChange={handleSearchChange}
              />
            )}
          </div>


          {/* Table */}
          {selectedPrefix && (
            <table className="table table-bordered table-shadow">
              <thead>
                <tr>
                  <th scope="col">S.No.</th>
                  <th scope="col">Template Name</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentRecords.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">No Templates found.</td>
                  </tr>
                ) : (
                  currentRecords.map((item, index) => {
                    if (!item || !item.displayName || !item.fullName) {
                      console.warn("Invalid item:", item);
                      return null;
                    }

                    const serialNumber = (currentPage - 1) * recordsPerPage + index + 1;

                    return (
                      <tr key={index}>
                        <td>{serialNumber}</td>
                        <td style={ListofTableFontsize}>{formatTableName(item.displayName)}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-sm btn-AddData rounded-0"
                            onClick={() => handleTableClick(item.fullName)}
                          >
                            Modify
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Pagination */}
      <PaginationComponent
        currentPage={currentPage}
        totalPages={totalPages}
        paginate={paginate}
        recordsPerPage={recordsPerPage}
        tableNames={filteredRecordsMemo}
      />
    </>
  );
};


export const TemplatePagination = ({
  currentPage,
  itemsPerPage,
  totalItems,
  onPageChange,
}) => {
  if (totalItems <= itemsPerPage) return null; // Hide pagination if not needed

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const visiblePages = 3; // Adjust visible pages to display (increase this if needed)

  // Calculate the range of visible pages
  let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  let endPage = Math.min(totalPages, startPage + visiblePages - 1);

  if (endPage - startPage + 1 < visiblePages) {
    startPage = Math.max(1, endPage - visiblePages + 1);
  }

  return (
    <div
      className="pagination-container"
      style={{ display: 'flex', justifyContent: 'center', marginTop: '1%' }}
    >
      <nav aria-label="Page navigation">
        <ul className="pagination">
          {/* Previous button */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(currentPage - 1)}
              style={{ color: '#26b7ec' }}
              disabled={currentPage === 1}
            >
              Previous
            </button>
          </li>

          {/* Ellipses for start */}
          {startPage > 1 && (
            <>
              <li className="page-item">
                <button className="page-link" onClick={() => onPageChange(1)}>
                  1
                </button>
              </li>
              {startPage > 2 && (
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              )}
            </>
          )}


          {/* Visible pages */}
          {[...Array(endPage - startPage + 1)].map((_, index) => (
            <li
              key={startPage + index}
              className={`page-item ${currentPage === startPage + index ? 'active' : ''
                }`}
            >
              <button
                className="page-link"
                onClick={() => onPageChange(startPage + index)}
              >
                {startPage + index}
              </button>
            </li>
          ))}

          {/* Ellipses for end */}
          {endPage < totalPages && (
            <>
              {endPage < totalPages - 1 && (
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              )}
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={() => onPageChange(totalPages)}
                >
                  {totalPages}
                </button>
              </li>
            </>
          )}

          {/* Next button */}
          <li
            className={`page-item ${currentPage === totalPages ? 'disabled' : ''
              }`}
          >
            <button
              className="page-link"
              onClick={() => onPageChange(currentPage + 1)}
              style={{ color: '#26b7ec' }}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export const BackupTableComponent = ({ backupTables, handleShowModal, previewRedirect, RestoreButtonStyle, previewButtonStyle }) => {
  return (
    <table className="table table-striped table-bordered table-hover" style={{ borderCollapse: 'collapse', width: '70%', margin: 'auto' }}>
      <thead className='sticky-top' style={TableHeader1}>
        <tr>
          <th className="text-center" style={TableHeader1}>TableName</th>
          <th className="text-center" style={TableHeader1}>BackupDate</th>
          <th className="text-center" style={TableHeader1}>Actions</th>
        </tr>
      </thead>
      <tbody style={
        // { border: '1px solid black', padding: '5px', fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
        tbodyStyles
      }>
        {backupTables.map((table, index) => (
          <tr key={index} style={{ lineHeight: '25px' }}>
            <td style={

              tableCellStyle(index)

            }>
              {/* {table.tableName.split('_')[0].charAt(0).toUpperCase() + table.tableName.split('_')[0].slice(1)} */}
              {table.tableName
                .replace(/_temp_backup_\d+$/, '') // Remove "_temp_backup_" followed by digits at the end
                .replace(/_/g, ' ') // Replace underscores with spaces
                .split(' ') // Split by spaces
                .map((word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize each word
                )
                .join(' ')} {/* Join the words back with spaces */}
            </td>
            <td style={

              tableCellStyle(index)

            }>
              {table.backupDate}
            </td>
            <td style={

              tableCellStyle(index)

            }>


              <button
                type="button"
                className="btn btn-light btn-sm "
                data-toggle="tooltip"
                data-placement="Left"
                title="Click to Restore"
                style={{
                  marginLeft: '15px',
                  // padding: '2px',
                  // fontSize: '10px',
                  border: 'none',
                  backgroundColor: 'transparent',
                }}
                onClick={() => handleShowModal(table.tableName)}
              >
                {/* Icon with green fill and white border */}
                <link
                  href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                  rel="stylesheet"
                />
                <i
                  className="bi bi-arrow-repeat"
                  style={{
                    fontSize: '1.3rem', // Icon size
                    color: 'black',   // Green color for success
                    marginRight: '10px',
                    lineHeight: '7px'
                  }}
                ></i>
              </button>


              <button
                type="button"
                // className="btn btn-light btn-sm"
                className="btn btn-light btn-sm"

                data-toggle="tooltip"
                data-placement="Left"
                title="Click to Preview"
                style={{

                  border: 'none',            // No border for the button
                  backgroundColor: 'transparent', // Transparent background for the button
                }}
                onClick={() => previewRedirect(table.tableName)}
              >

                <i
                  className="bi bi-eye-fill"
                  style={{
                    fontSize: '1.3rem',
                    marginRight: '5px',
                    // Icon size,
                    lineHeight: '5px',
                    color: '#E67016',

                  }}
                ></i>
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};


export const TemplateformTableStructure = ({ currentRecords, modifyTemplate }) => {
  return (
    <div className="col-lg-9">
      <table
        className="table table-bordered table-shadow"
        style={{ borderCollapse: 'collapse', margin: 'auto' }}
      >
        <thead style={{ textAlign: 'center' }}>
          <tr>
            <th scope="col" style={TableHeader1}>Table Name</th>
            <th scope="col" style={TableHeader1}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentRecords.map((item, index) => {
            // Apply the transformation to format the table name
            const formattedTableName = item
              .replace(/_/g, ' ') // Replace underscores with spaces
              .split(' ') // Split by spaces
              .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
              .join(' '); // Join the words back with spaces

            return (
              <tr key={index}>
                <td style={ListofTableFontsize}>{formattedTableName}</td> {/* Display the formatted table name */}
                <td>
                  <button
                    key={index}
                    className="btn btn-sm btn-custom rounded-0"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Click to Modify"
                    // style={submitButtonStyle}
                    onClick={() => modifyTemplate(item)} // Pass the actual table name to the function
                  >
                    Modify
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};



export const PaginationComponentForm1 = ({
  currentPage,
  totalPages,
  paginate,
  recordsPerPage,
  tableNames,
}) => {
  const maxVisiblePages = 4; // Number of visible pages at a time

  const getVisiblePageNumbers = () => {
    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // If total pages are less than or equal to maxVisiblePages, show all
      pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    } else {
      // Calculate the range of pages to show
      const halfRange = Math.floor(maxVisiblePages / 2);
      let startPage = currentPage - halfRange;
      let endPage = currentPage + halfRange;

      if (startPage <= 1) {
        startPage = 1;
        endPage = maxVisiblePages;
      } else if (endPage >= totalPages) {
        startPage = totalPages - maxVisiblePages + 1;
        endPage = totalPages;
      }

      pages = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

      // Add ellipses
      if (startPage > 1) {
        pages = [1, '...', ...pages];
      }
      if (endPage < totalPages) {
        pages = [...pages, '...', totalPages];
      }
    }

    // Ensure unique values in pages array
    return [...new Set(pages)];
  };
  const pageNumbers = getVisiblePageNumbers();
  return (
    <>
      {totalPages > 1 && (
        <div className="" style={{ marginTop: '10px' }}>
          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-center">
              {/* Previous button */}
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  style={{ color: '#26b7ec' }}
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>

              {/* Visible pages with ellipses */}
              {pageNumbers.map((pageNumber, index) => (
                pageNumber === '...' ? (
                  <li key={`ellipsis-${index}`} className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                ) : (
                  <li
                    key={pageNumber}
                    className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}
                  >
                    <button
                      className="page-link"
                      style={{ color: '#26b7ec' }}
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                )
              ))}

              {/* Next button */}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  style={{ color: '#26b7ec' }}
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </>
  );
};


export const PaginationComponentForm2 = ({
  currentPage,
  totalPages,
  paginate
}) => {
  const maxVisiblePages = 5;
  const [inputPage, setInputPage] = useState('');

  const getVisiblePageNumbers = () => {
    if (totalPages <= 4) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [1];

    if (currentPage === 1) {
      pages.push(2);
      pages.push('...');
    } else if (currentPage === 2) {
      pages.push(2);
      pages.push(3);
      pages.push('...');
    } else if (currentPage === totalPages - 1) {
      pages.push('...');
      pages.push(totalPages - 2);
      pages.push(totalPages - 1);
    } else if (currentPage === totalPages) {
      pages.push('...');
      pages.push(totalPages - 1);
    } else {
      // For middle pages:
      // Check if currentPage -1 is adjacent to 1 (which is page 2)
      if (currentPage - 1 === 2) {
        pages.push(2);
      } else {
        pages.push('...');
        pages.push(currentPage - 1);
      }

      pages.push(currentPage);

      // Check if currentPage +1 is adjacent to last page -1
      if (currentPage + 1 === totalPages - 1) {
        pages.push(currentPage + 1);
      } else {
        pages.push(currentPage + 1);
        pages.push('...');
      }
    }

    pages.push(totalPages);

    return pages;
  };

  const pageNumbers = getVisiblePageNumbers();

  return (
    <div className="table-on-homepage-only">
      <div className="d-flex justify-content-center align-items-center mt-half pagination-container">
        <div
          className="rounded-pill shadow-sm px-2 py-0 d-flex align-items-center gap-1"
          style={{
            fontSize: '0.8rem',
            border: '1px solid #366872',
          }}
        >
          {/* Previous */}
          <button
            className="btn btn-light btn-sm pagination-btn"
            disabled={currentPage === 1}
            onClick={() => paginate(currentPage - 1)}
            style={{ padding: '2px 8px' }}
          >
            &lt;
          </button>

          {/* Pages */}
          {pageNumbers.map((pageNumber, index) =>
            pageNumber === '...' ? (
              <span key={`ellipsis-${index}`} className="text-muted px-1">...</span>
            ) : (
              <button
                key={pageNumber}
                className={`btn btn-sm pagination-btn ${currentPage === pageNumber ? 'active' : ''}`}
                onClick={() => paginate(pageNumber)}
                style={{ padding: '2px 8px', minWidth: '30px' }}
              >
                {pageNumber}
              </button>
            )
          )}

          {/* Next */}
          <button
            className="btn btn-light btn-sm pagination-btn"
            disabled={currentPage === totalPages}
            onClick={() => paginate(currentPage + 1)}
            style={{ padding: '2px 8px' }}
          >
            &gt;
          </button>

        </div>
      </div>
    </div>
  );
};


export const PaginationComponentForm = ({
  currentPage,
  totalPages,
  paginate,
  recordsPerPage,
  tableNames,
}) => {
  const maxVisiblePages = 4; // Number of visible pages at a time

  const getVisiblePageNumbers = () => {
    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // If total pages are less than or equal to maxVisiblePages, show all
      pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    } else {
      // Calculate the range of pages to show
      const halfRange = Math.floor(maxVisiblePages / 2);
      let startPage = currentPage - halfRange;
      let endPage = currentPage + halfRange;

      if (startPage <= 1) {
        startPage = 1;
        endPage = maxVisiblePages;
      } else if (endPage >= totalPages) {
        startPage = totalPages - maxVisiblePages + 1;
        endPage = totalPages;
      }

      pages = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

      // Add ellipses
      if (startPage > 1) {
        pages = [1, '...', ...pages];
      }
      if (endPage < totalPages) {
        pages = [...pages, '...', totalPages];
      }
    }

    // Ensure unique values in pages array
    return [...new Set(pages)];
  };
  const pageNumbers = getVisiblePageNumbers();
  return (
    <>
      {tableNames.length > recordsPerPage && (
        <div className="" style={{ marginTop: '20px' }}>
          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-center">
              {/* Previous button */}
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  style={{ color: '#26b7ec' }}
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>

              {/* Visible pages with ellipses */}
              {pageNumbers.map((pageNumber, index) => (
                pageNumber === '...' ? (
                  <li key={`ellipsis-${index}`} className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                ) : (
                  <li
                    key={pageNumber}
                    className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}
                  >
                    <button
                      className="page-link"
                      style={{ color: '#26b7ec' }}
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                )
              ))}

              {/* Next button */}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  style={{ color: '#26b7ec' }}
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </>
  );
};


export const DEMcheckertableStructure = ({
  onSelectedRowIdsChange,
  selectedColumn, // received as prop
  handleDropdownChange, // received as prop
  isLoading,
  error,
  currentRecords,
  tableData,
  tableColumns,
  totalPages,
  currentPage,
  paginate,
  handleApprove,
  handleReject,
  handleApproveBulk,
  handleBulkReject,
  selectedRowIdToSend,
  // showBulkActions
  searchTerm, // Add this
  filteredTableData, // Add this
  isRetrievedTable
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [Updatedcolumns, setUpdatedcolumns] = useState([]); // Changed to an array
  const [showMakerRemarks, setShowMakerRemarks] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const formatCellValue = (value) => {
    const nullLikeValues = ["\\N", "\N", "NULL", "null", null, undefined];

    if (nullLikeValues.includes(value)) {
      return "";
    }

    return value;
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const formatColumnName = (columnName) => {
    // Replace underscores with spaces and convert to proper case
    return columnName
      .replace(/_/g, ' ')  // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
      .replace(/\s+/g, ' '); // Clean up multiple spaces
  };

  const isValidRow = (item) => {
    const rejectedReason = (item.Rejected_Reason || "").trim();
    const nullLikeValues = ["\\N", "\N", "NULL", ""];

    if (isRetrievedTable) {
      if (item.flag === "M") {
        return rejectedReason === "Ready for validation. (updated)";
      }

      if (item.flag === "R") {
        return nullLikeValues.includes(rejectedReason);
      }

      return false; // Only M and R flags allowed
    } else {
      return !rejectedReason || nullLikeValues.includes(rejectedReason);
    }
  };

  useEffect(() => {
    const validRowIds = tableData
      .filter(item => isValidRow(item))
      .map(item => item.rowId);

    const updatedSelectedRowIds = selectedRowIds.filter(id => validRowIds.includes(id));
    setSelectedRowIds(updatedSelectedRowIds);
  }, [tableData]);


  const handleCheckboxChange = (rowId) => {
    setSelectedRowIds((prev) => {
      let updated;
      if (prev.includes(rowId)) {
        updated = prev.filter(id => id !== rowId);
      } else {
        updated = [...prev, rowId];
      }
      onSelectedRowIdsChange(updated);  // This is the prop function from the parent
      return updated;
    });
  };


  const handleCheckboxChangeAudit = (key) => {
    setUpdatedcolumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    );

  };


  const handleSelectAll = () => {
    const dataSource = searchTerm ? filteredTableData : tableData;

    const allSelectableRowIds = dataSource
      .filter(item => isValidRow(item))
      .map(item => item.rowId);

    const isAllSelected = allSelectableRowIds.length > 1 &&
      allSelectableRowIds.every(rowId => selectedRowIds.includes(rowId));

    const updatedSelection = isAllSelected ? [] : allSelectableRowIds;

    setSelectedRowIds(updatedSelection);
    onSelectedRowIdsChange(updatedSelection);
  };

  if (isLoading) {
    return (
      <TableLoading />
    );
  }

  if (error) {
    return <p>{error}</p>; // Show error message
  }

  if (currentRecords.length === 0) {
    return (
      <div className="text-center mt-4 text-muted">
        <strong>Nothing Pending for Review</strong>
      </div>
    );
  }
  const hasRecords = tableData.length > 0;
  const hasRejectedRecords = tableData.some(item => isValidRow(item));

  if (!hasRecords || !hasRejectedRecords) {
    return (
      <div className="text-center mt-4 text-muted">
        <strong>Nothing Pending for Review</strong>
      </div>
    );
  }
  const allSelectableRowIds = tableData
    .filter(
      (item) =>
        item.Rejected_Reason === "\\N" ||
        item.Rejected_Reason === "\N" ||
        item.Rejected_Reason === "NULL"
    )
    .map((item) => item.rowId);

  const baseOptions = [
    { key: 'created_by', label: 'Created By' },
    { key: 'created_dt', label: 'Created Date' },
    { key: 'modified_by', label: 'Modified By' },
    { key: 'modified_dt', label: 'Modified Date' },
  ];

  const retrievedOptions = [
    { key: 'approved_by', label: 'Approved By' },
    { key: 'approved_dt', label: 'Approved Date' },
  ];

  const dropdownOptions = isRetrievedTable
    ? [...baseOptions, ...retrievedOptions]
    : baseOptions;

  return (

    <div className="row">
      <div className="col">
        <div className="table-on-homepage-only">
          <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
            <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>

              <thead className="sticky-header">
                <tr>
                  {/* <tr> */}
                  <th scope="col" style={{ textAlign: 'center' }}>

                    <input
                      type="checkbox"
                      checked={
                        (searchTerm ? filteredTableData : tableData)
                          .filter(item =>
                            item.Rejected_Reason === "\\N" ||
                            item.Rejected_Reason === "\N" ||
                            item.Rejected_Reason === "NULL"
                          )
                          .every(item => selectedRowIds.includes(item.rowId)) &&
                        selectedRowIds.length > 1
                      }
                      onChange={handleSelectAll}
                      style={{ margin: '0 auto' }}

                    />

                  </th>

                  {tableColumns.map((key, index) => (
                    key !== "Maker_Remarks" && // Skip Maker_Remarks here
                    !['rowId', 'row_id', 'Rejected_Reason', 'active_yn', 'dataModel', 'approved_by', 'approved_dt', 'flag'].includes(key) &&
                    !dropdownOptions.some((option) => option.key === key) && (
                      <th scope="col" key={index}>{formatColumnName(key)}</th>
                    )
                  ))}

                  {tableData.some(
                    (item) =>
                      item.Maker_Remarks &&
                      !["\\N", "//N", "/N", "NULL", ""].includes(item.Maker_Remarks)
                  ) && (
                      <th scope="col">Maker Remarks</th>
                    )}

                  {Updatedcolumns.length > 0 &&
                    Updatedcolumns.map((column) => (
                      <th key={column} scope="col">
                        {formatColumnName(dropdownOptions.find((option) => option.key === column)?.label || column)}
                      </th>
                    ))}
                  <th scope="col" style={{ position: 'sticky' }}>
                    Actions
                    <div
                      ref={dropdownRef}
                      style={{
                        position: 'sticky',
                        display: 'inline-block',
                        marginLeft: '10px',
                      }}
                    >
                      <button
                        onClick={toggleDropdown}
                        style={{
                          color: 'black',
                          border: 'none',
                          background: 'transparent',
                          cursor: 'pointer',
                        }}
                      >
                        <i className="bi bi-caret-down-square" style={{ color: 'black' }}></i>
                      </button>
                      {showDropdown && (
                        <div
                          style={{
                            position: 'fixed',
                            top: '174px',
                            right: '10px',
                            backgroundColor: 'white',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                            zIndex: '1000',
                            borderRadius: '4px',
                            minWidth: '150px',
                            color: 'black',
                            padding: '5px',
                          }}
                        >
                          {dropdownOptions.map((option) => (
                            <div
                              key={option.key}
                              style={{
                                display: 'flex',
                                alignItems: 'left',
                                cursor: 'pointer',
                                transition: 'background 0.2s',
                                padding: '3px 5px',
                                fontWeight: 'normal',
                                fontSize: '14px',
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={Updatedcolumns.includes(option.key)}
                                onChange={() => handleCheckboxChangeAudit(option.key)}
                                style={{ marginRight: '8px' }}
                                onMouseEnter={(e) => (e.target.style.background = '#f5f5f5')}
                                onMouseLeave={(e) => (e.target.style.background = 'transparent')}
                              />
                              {option.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody style={tbodyStyles}>
                {currentRecords.map((item, rowIndex) => (
                  isValidRow(item) && (
                    <tr key={rowIndex} style={{
                      boxShadow: rowIndex % 2 === 0 ? '2px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 0px 0px rgba(0, 0, 0, 0.2)',
                      padding: '5px',
                      height: '10px',
                      lineHeight: '30px'
                    }}>
                      <td style={{
                        ...tableCellStyle(rowIndex),
                        textAlign: 'center'  // Center align the cell content
                      }}>

                        <input
                          type="checkbox"
                          checked={selectedRowIds.includes(item.rowId)}
                          onChange={() => handleCheckboxChange(item.rowId)}
                          style={{
                            display: 'block',  // Make it a block element for margin auto to work
                            margin: '0 auto'   // Center horizontally
                          }}
                        />

                      </td>

                      {Object.keys(item).map((key, colIndex) => (
                        key !== "Maker_Remarks" &&
                        !['rowId', 'row_id', 'Rejected_Reason', 'active_yn', 'dataModel', 'approved_by', 'approved_dt', 'flag'].includes(key) &&
                        !dropdownOptions.some((option) => option.key === key) && (
                          // <td key={colIndex} style={tableCellStyle(rowIndex)}>{item[key]}</td>
                          <td key={colIndex} style={tableCellStyle(rowIndex)}>
                            {formatCellValue(item[key])}
                          </td>

                        )
                      ))}

                      {/* Show Maker_Remarks only if the header is shown */}
                      {tableData.some(
                        (item) =>
                          item.Maker_Remarks &&
                          !["\\N", "//N", "/N", "NULL", ""].includes(item.Maker_Remarks)
                      ) && (
                          <td style={tableCellStyle(rowIndex)}>
                            {/* {["\\N", "//N", "/N", "NULL", ""].includes(item.Maker_Remarks)
                              ? ""
                              : item.Maker_Remarks} */}
                            {formatCellValue(item.Maker_Remarks)}

                          </td>
                        )}


                      {Updatedcolumns.length > 0 &&
                        Updatedcolumns.map((column) => (
                          <td key={column} style={tableCellStyle(rowIndex)}>
                            {/* {item[column] || 'N/A'} */}
                            {formatCellValue(item[column])}
                          </td>
                        ))}
                      <td style={{
                        whiteSpace: 'nowrap',
                        // border: '1px solid black',
                        padding: '0px',
                        textAlign: 'center',
                        // backgroundColor: rowIndex % 2 === 0 ?  '#ffffff': '#f2f2f2'
                        backgroundColor: rowIndex % 2 === 0 ? '#ffffff' : '#ffffff'
                      }}>
                        <button
                          type="button"
                          className="btn btn-light btn-sm "
                          data-toggle="tooltip"
                          data-placement="Left"
                          title={selectedRowIds.length > 1 ? "Disabled - Multiple items selected" : "Click to Approve"}
                          style={{ marginLeft: '15px', border: 'none', backgroundColor: 'transparent' }}
                          onClick={selectedRowIds.length > 1 ? undefined : () => handleApprove(item.rowId)}
                          disabled={selectedRowIds.length > 1}
                        >

                          <link
                            href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                            rel="stylesheet"
                          />
                          <i
                            className="bi bi-check-circle"
                            style={{
                              ...ApporveIcon,
                              marginRight: '10px'
                            }}
                          ></i>
                        </button>

                        <button
                          type="button"
                          className="btn btn-light btn-sm"
                          title={selectedRowIds.length > 1 ? "Disabled - Multiple items selected" : "Click to Reject"}
                          style={{
                            border: 'none',
                            backgroundColor: 'transparent',
                            opacity: selectedRowIds.length > 1 ? 0.5 : 1,
                            cursor: selectedRowIds.length > 1 ? 'not-allowed' : 'pointer'
                          }}
                          onClick={selectedRowIds.length > 1 ? undefined : () => handleReject(item.rowId)}
                          disabled={selectedRowIds.length > 1}
                        >
                          <i className="bi bi-x-circle" style={{ marginRight: '5px', ...RejectIcon }}></i>
                        </button>

                      </td>
                    </tr>
                  )
                ))}
              </tbody>
            </table>
          </div>
        </div>


      </div>

    </div>
  );
};


export const GapsycheckertableStructure = ({
  onSelectedRowIdsChange,
  selectedColumn, // received as prop
  handleDropdownChange, // received as prop
  isLoading,
  error,
  currentRecords,
  tableData,
  tableColumns,
  totalPages,
  currentPage,
  paginate,
  handleApprove,
  handleReject,
  handleApproveBulk,
  handleBulkReject,
  searchTerm,
  showConfirmApprove,
  setShowConfirmApprove,
  showRejectModal,
  setShowRejectModal,
  setClickedRowId,
  setSelectedColumn,
  setOtherReason,
  selectedRowIdToSend
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [Updatedcolumns, setUpdatedcolumns] = useState([]); // Changed to an array
  const [showMakerRemarks, setShowMakerRemarks] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [checkboxRowId, setCheckboxRowId] = useState([]);
  const [showBulkActions, setShowBulkActions] = useState(false);


  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    if (!showConfirmApprove && !showRejectModal) {
      setSelectedRowIds([]);
      setShowBulkActions(false);
    }
  }, [showConfirmApprove, showRejectModal]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  useEffect(() => {
    const validRowIds = tableData
      .filter(
        (item) =>
          item.Rejected_Reason === "\\N" ||
          item.Rejected_Reason === "\N" ||
          item.Rejected_Reason === "NULL"
      )
      .map((item) => item.rowId); // adjust this if your row ID key is different

    const updatedSelectedRowIds = selectedRowIds.filter((id) => validRowIds.includes(id));
    setSelectedRowIds(updatedSelectedRowIds);
  }, [tableData]);


  const handleCheckboxChange = (rowId) => {
    setSelectedRowIds((prev) => {
      let updated;
      if (prev.includes(rowId)) {
        updated = prev.filter(id => id !== rowId);
      } else {
        updated = [...prev, rowId];
      }
      setSelectedRowIds(updated);
      onSelectedRowIdsChange(updated);  // This is the prop function from the parent
      // Show bulk actions when 2+ items are selected
      setShowBulkActions(updated.length >= 2);
      return updated;
    });
  };



  const handleCheckboxChangeAudit = (key) => {
    setUpdatedcolumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    );

  };

  const handleSelectAll = () => {
    const allSelectableRowIds = tableData
      .filter(item =>
        item.Rejected_Reason === "\\N" ||
        item.Rejected_Reason === "\N" ||
        item.Rejected_Reason === "NULL"
      )
      .map(item => item.rowId);

    const isAllSelected = allSelectableRowIds.every(rowId => selectedRowIds.includes(rowId));
    const updatedSelection = isAllSelected ? [] : allSelectableRowIds;
    setShowBulkActions(updatedSelection.length >= 2);
    setSelectedRowIds(updatedSelection);
    onSelectedRowIdsChange(updatedSelection);
  };


  if (isLoading) {
    return (
      <TableLoading />
    );
  }

  if (error) {
    return <p>{error}</p>; // Show error message
  }


  // Consolidated check for empty state
  const reviewableRecords = tableData.some(item =>
    item.Rejected_Reason === "\\N" ||
    item.Rejected_Reason === "\N" ||
    item.Rejected_Reason === "NULL"
  );

  // Only show "Nothing Pending" when there are truly no reviewable records
  if (reviewableRecords.length === 0) {
    return <p>Nothing Pending for Review</p>;
  }

  const allSelectableRowIds = tableData
    .filter(
      (item) =>
        item.Rejected_Reason === "\\N" ||
        item.Rejected_Reason === "\N" ||
        item.Rejected_Reason === "NULL"
    )
    .map((item) => item.rowId);


  const dropdownOptions = [

    { key: 'created_by', label: 'Created By' },
    { key: 'created_dt', label: 'Created Date' },
    { key: 'modified_by', label: 'Modified By' },
    { key: 'modified_dt', label: 'Modified Date' },
  ];

  // Utility function to format column names
  const formatColumnName = (columnName) => {
    // Replace underscores with spaces and convert to proper case
    return columnName
      .replace(/_/g, ' ')  // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
      .replace(/\s+/g, ' '); // Clean up multiple spaces
  };

  return (
    <div className="row">
      <div className="col">
        <div className="table-on-homepage-only">
          <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
            <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>

              <thead className="sticky-header">
                <tr>
                  {/* <tr> */}
                  <th scope="col" style={{ textAlign: 'center' }}>

                    <input
                      type="checkbox"
                      checked={
                        tableData
                          .filter(item =>
                            item.Rejected_Reason === "\\N" ||
                            item.Rejected_Reason === "\N" ||
                            item.Rejected_Reason === "NULL"
                          )
                          .every(item => selectedRowIds.includes(item.rowId))
                      }
                      onChange={handleSelectAll}
                      style={{ margin: '0 auto' }}

                    />
                  </th>
                  {tableColumns.map((key, index) => (
                    key !== "Maker_Remarks" && // Skip Maker_Remarks here
                    !['rowId', 'Rejected_Reason', 'active_yn', 'dataModel'].includes(key) &&
                    !dropdownOptions.some((option) => option.key === key) && (
                      <th scope="col" key={index}>{formatColumnName(key)}</th>
                    )
                  ))}

                  {tableData.some(
                    (item) =>
                      item.Maker_Remarks &&
                      !["\\N", "//N", "/N", "NULL", ""].includes(item.Maker_Remarks)
                  ) && (
                      <th scope="col">Maker Remarks</th>
                    )}

                  {Updatedcolumns.length > 0 &&
                    Updatedcolumns.map((column) => (
                      <th key={column} scope="col">
                        {formatColumnName(dropdownOptions.find((option) => option.key === column)?.label || column)}
                      </th>
                    ))}
                  <th scope="col" style={{ position: 'sticky' }}>
                    Actions
                    <div
                      ref={dropdownRef}
                      style={{
                        position: 'sticky',
                        display: 'inline-block',
                        marginLeft: '10px',
                      }}
                    >
                      <button
                        onClick={toggleDropdown}
                        style={{
                          color: 'black',
                          border: 'none',
                          background: 'transparent',
                          cursor: 'pointer',
                        }}
                      >
                        <i className="bi bi-caret-down-square" style={{ color: 'black' }}></i>
                      </button>
                      {showDropdown && (
                        <div
                          style={{
                            position: 'fixed',
                            top: '174px',
                            right: '10px',
                            backgroundColor: 'white',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                            zIndex: '1000',
                            borderRadius: '4px',
                            minWidth: '150px',
                            color: 'black',
                            padding: '5px',
                          }}
                        >
                          {dropdownOptions.map((option) => (
                            <div
                              key={option.key}
                              style={{
                                display: 'flex',
                                alignItems: 'left',
                                cursor: 'pointer',
                                transition: 'background 0.2s',
                                padding: '3px 5px',
                                fontWeight: 'normal',
                                fontSize: '14px',
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={Updatedcolumns.includes(option.key)}
                                onChange={() => handleCheckboxChangeAudit(option.key)}
                                style={{ marginRight: '8px' }}
                                onMouseEnter={(e) => (e.target.style.background = '#f5f5f5')}
                                onMouseLeave={(e) => (e.target.style.background = 'transparent')}
                              />
                              {option.label}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody style={tbodyStyles}>
                {currentRecords.map((item, rowIndex) => (
                  (item.Rejected_Reason === "\\N" || item.Rejected_Reason === "\N" || item.Rejected_Reason === "NULL") && (
                    <tr key={rowIndex} style={{
                      boxShadow: rowIndex % 2 === 0 ? '2px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 0px 0px rgba(0, 0, 0, 0.2)',
                      padding: '5px',
                      height: '10px',
                      lineHeight: '30px'
                    }}>
                      <td style={{
                        ...tableCellStyle(rowIndex),
                        textAlign: 'center'  // Center align the cell content
                      }}>

                        <input
                          type="checkbox"
                          checked={selectedRowIds.includes(item.rowId)}
                          onChange={() => handleCheckboxChange(item.rowId)}
                          style={{
                            display: 'block',  // Make it a block element for margin auto to work
                            margin: '0 auto'   // Center horizontally
                          }}
                        />

                      </td>

                      {Object.keys(item).map((key, colIndex) => (
                        key !== "Maker_Remarks" &&
                        !['rowId', 'Rejected_Reason', 'active_yn', 'dataModel'].includes(key) &&
                        !dropdownOptions.some((option) => option.key === key) && (
                          <td key={colIndex} style={tableCellStyle(rowIndex)}>{item[key]}</td>
                        )
                      ))}

                      {/* Show Maker_Remarks only if the header is shown */}
                      {tableData.some(
                        (item) =>
                          item.Maker_Remarks &&
                          !["\\N", "//N", "/N", "NULL", ""].includes(item.Maker_Remarks)
                      ) && (
                          <td style={tableCellStyle(rowIndex)}>
                            {["\\N", "//N", "/N", "NULL", ""].includes(item.Maker_Remarks)
                              ? ""
                              : item.Maker_Remarks}
                          </td>
                        )}


                      {Updatedcolumns.length > 0 &&
                        Updatedcolumns.map((column) => (
                          <td key={column} style={tableCellStyle(rowIndex)}>
                            {item[column] || 'N/A'}
                          </td>
                        ))}
                      <td style={{
                        whiteSpace: 'nowrap',
                        // border: '1px solid black',
                        padding: '0px',
                        textAlign: 'center',
                        // backgroundColor: rowIndex % 2 === 0 ?  '#ffffff': '#f2f2f2'
                        backgroundColor: rowIndex % 2 === 0 ? '#ffffff' : '#ffffff'
                      }}>
                        <button
                          type="button"
                          className="btn btn-light btn-sm "
                          data-toggle="tooltip"
                          data-placement="Left"
                          title={selectedRowIds.length > 1 ? "Disabled - Multiple items selected" : "Click to Approve"}
                          style={{ marginLeft: '15px', border: 'none', backgroundColor: 'transparent' }}
                          onClick={selectedRowIds.length > 1 ? undefined : () => handleApprove(item.rowId)}
                          disabled={selectedRowIds.length > 1}
                        >

                          <link
                            href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                            rel="stylesheet"
                          />
                          <i
                            className="bi bi-check-circle"
                            style={{
                              ...ApporveIcon,
                              marginRight: '10px'
                            }}
                          ></i>
                        </button>

                        <button
                          type="button"
                          className="btn btn-light btn-sm"
                          title={selectedRowIds.length > 1 ? "Disabled - Multiple items selected" : "Click to Reject"}
                          style={{
                            border: 'none',
                            backgroundColor: 'transparent',
                            opacity: selectedRowIds.length > 1 ? 0.5 : 1,
                            cursor: selectedRowIds.length > 1 ? 'not-allowed' : 'pointer'
                          }}
                          onClick={selectedRowIds.length > 1 ? undefined : () => handleReject(item.rowId)}
                          disabled={selectedRowIds.length > 1}
                        >
                          <i className="bi bi-x-circle" style={{ marginRight: '5px', ...RejectIcon }}></i>
                        </button>

                      </td>
                    </tr>
                  )
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-2 mb-2 px-2">
          {!isLoading && selectedRowIds.length > 0 && (
            <div className="text-start" style={{ fontSize: '12px' }}>
              {selectedRowIds.length} out of {allSelectableRowIds.length} records selected
            </div>
          )}

          {/* Bulk actions - only show when not loading and has bulk selections */}
          {!isLoading && showBulkActions && selectedRowIds.length >= 2 && (
            <div className="text-end">
              <button
                type="button"
                className="btn btn-light btn-sm custom-btn me-2"
                onClick={() => handleApproveBulk(selectedRowIdToSend)}
                style={{ ...Aprrovecolor, color: "white" }}
              >
                Approve
              </button>
              <button
                type="button"
                className="btn btn-light btn-sm custom-btn"
                onClick={() => handleBulkReject(selectedRowIdToSend)}
                // onClick={() => handleBulkReject(selectedRowIds.join(','))}
                style={{ ...Rejectcolor, color: 'white' }}
              >
                Reject
              </button>
            </div>
          )}
        </div>
      </div>

    </div>
  );
};

export const BulkModifyTablestructure = ({
  isLoading,
  error,
  currentRecords,
  tableData,
  tableColumns,
  editingIndex,
  handleInputChange,
  handleSave,
  handleCancel,
  handleEdit,
  handleDeleteClick,
  primaryKeyColumn,
  paginate,
  currentPage,
  totalPages
}) => {
  if (isLoading) {
    return <TableLoading />
  }
  if (error) {
    return <p>{error}</p>; // Show error message
  }
  if (currentRecords.length === 0) {
    return <p>Nothing Pending for Modification</p>;
  }

  const hasRecords = tableData.length > 0;

  const hasRejectedRecords = tableData.some(item => (
    item.Rejected_Reason !== "Ready for validation. (updated)" &&
    item.Rejected_Reason !== "\\N" &&
    item.Rejected_Reason !== "" && item.Rejected_Reason !== "\N") &&
    (item.active_yn !== 'N' && item.active_yn !== "N")
  );

  if (!hasRecords || !hasRejectedRecords) {
    return <p>Nothing Pending for Review</p>;
  }


  return (
    <div>
      <div style={{ maxHeight: 'calc(100vh - 265px)', overflowY: 'auto', overflowX: 'auto', marginTop: '10px' }}>
        <table className={tableClassStyle.className} style={tableClassStyle.style}>
          {hasRejectedRecords && (
            <thead className='sticky-top' style={TableHeader1}>
              <tr>

                {tableColumns.map((key, index) => (
                  key !== 'rowId' && (
                    (editingIndex === null || key !== 'Rejected_Reason') && (
                      <th scope="col" key={index} style={TableHeader1}>{key}</th>
                    ))
                ))}
                <th scope="col" style={TableHeader1}>Actions</th>
              </tr>
            </thead>
          )}
          <tbody style={tbodyStyles}>
            {currentRecords.map((item, rowIndex) => (
              (editingIndex === null || editingIndex === rowIndex) && (
                <tr key={rowIndex} style={{ boxShadow: rowIndex % 2 === 0 ? '2px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 0px 0px rgba(0, 0, 0, 0.2)', border: '1px solid black', padding: '5px', height: '15px', lineHeight: '15px' }}>
                  {Object.keys(item).map((key, colIndex) => (
                    key !== 'rowId' && key !== 'created_dt' && key !== 'created_by' && key !== 'modified_dt' &&
                    key !== 'modified_by' && key !== 'flag' && (
                      (editingIndex === null || key !== 'Rejected_Reason') && (
                        <td key={colIndex} style={
                          tableCellStyle(rowIndex)
                        }
                        >
                          {editingIndex === rowIndex ? (
                            key === "Rejected_Reason" || key === primaryKeyColumn ? (
                              item[key] // Display without input field for rejectedReason and primary key columns
                            ) : (
                              <input
                                type="text"
                                value={item[key]}
                                onChange={(e) => handleInputChange(e, key, rowIndex)}
                              />
                            )
                          ) : (
                            item[key] || ''
                          )}
                        </td>
                      )

                    )
                  ))}
                  <td style={
                    // { whiteSpace: 'nowrap', border: '1px solid black', padding: '2px', textAlign: 'center', backgroundColor: rowIndex % 2 === 0 ? '#f2f2f2' : '#ffffff' }
                    tableCellStyle(rowIndex)
                  }>
                    {editingIndex === rowIndex ? (
                      <>
                        <button
                          type="button"
                          className="btn btn-light btn-sm"
                          data-toggle="tooltip" data-placement="Left" title="Click to Submit"
                          style={
                            {
                              ...submit,
                              color: "white", fontSize: '12px', marginRight: '15px',
                            }
                          }
                          onClick={() => handleSave(rowIndex)}
                        >
                          Submit
                        </button>
                        <button
                          className="btn btn-secondary btn-sm"
                          data-toggle="tooltip" data-placement="Left" title="Click to Cancel"
                          style={
                            {
                              color: "white", fontSize: '12px', marginRight: '15px',
                            }
                          }
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        <div className=" ">
                          <button
                            className="btn btn-light btn-sm"
                            data-toggle="tooltip" data-placement="Left" title="Click to Edit"
                            style={{
                              ...Editcolor,
                              padding: '5px',
                              color: "white",
                              fontSize: '12px',
                              marginRight: '10px', width: '60px', height: '28px' // Prevents text from wrapping
                            }}
                            onClick={() => handleEdit(rowIndex)}
                          >
                            Edit
                          </button>

                          <button
                            className="btn btn-light btn-sm"
                            data-toggle="tooltip" data-placement="Left" title="Click to Delete"
                            style={{
                              ...Deletecolor,
                              padding: '5px',
                              fontSize: '12px',
                              color: "white",
                              marginRight: '10px', width: '60px', height: '28px',// Prevents text from wrapping
                              display: editingIndex !== null ? "none" : "inline-block",
                            }}
                            onClick={() => handleDeleteClick(rowIndex)}
                          >
                            Delete
                          </button>
                        </div>
                      </>
                    )}
                  </td>
                </tr>
              )
            ))}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && editingIndex === null && (
        <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />
      )}

    </div>
  );
};

const preprocessFormData = (details, formData) => {
  const updatedFormData = { ...formData };

  details.forEach(detail => {
    if (detail.columnActive === "N") {
      if (detail.columnKey === "NOT NULL") {
        // Assign default values based on columnType for NOT NULL columns
        switch (detail.columnType.toLowerCase()) {
          case "date":
            updatedFormData[detail.columnName] = "1970-01-01"; // Default valid date
            break;
          case "int":
            updatedFormData[detail.columnName] = 0; // Default integer value
            break;
          case "varchar":
            updatedFormData[detail.columnName] = ""; // Default string value
            break;
          default:
            updatedFormData[detail.columnName] = null; // Fallback for unknown types
        }
      } else if (detail.columnKey === "NULL") {
        // Assign null for columns that allow NULL values
        updatedFormData[detail.columnName] = null;
      }
    }
  });

  return updatedFormData;
};

export const FormStructureComponent = ({
  paramState,
  formStructure,
  formData,
  handleSubmit,
  renderInput,
  handleInputChange,
  valueMode,
  templateConfig   // ✅ Add this prop so it works like your manual form
}) => {
  if (!formStructure || !formStructure.details) return null;

  const processedFormData = preprocessFormData(formStructure.details, formData);

  const lockedFields = templateConfig?.lockedFields || [];
  const staticDisabledFields = templateConfig?.staticDisabledFields || [];

  const isFieldDisabled = (columnName) => {
    const col = columnName?.toLowerCase();

    if (lockedFields.includes(col)) return true;

    if (valueMode !== "raw" && staticDisabledFields.includes(col)) {
      return true;
    }

    return false;
  };
  // Filter only active fields
  const activeDetails = formStructure.details.filter(
    (detail) => detail.columnActive !== "N"
  );

  // Group fields in pairs (2 per row)
  const formFieldPairs = [];
  for (let i = 0; i < activeDetails.length; i += 2) {
    formFieldPairs.push(activeDetails.slice(i, i + 2));
  }
  const today = new Date().toISOString().split('T')[0];


  return (
    <form className="form" onSubmit={handleSubmit}>
      {formFieldPairs.map((pair, rowIndex) => (
        <div className="form-group row mb-3" key={rowIndex}>
          {pair.map((detail, colIndex) => {
            const isDropdown =
              detail.columnFunction &&
              detail.columnFunction.startsWith("dropdown:");
            let dropdownOptions = [];
            if (isDropdown) {
              dropdownOptions = detail.columnFunction
                .replace("dropdown:", "")
                .replace("[", "")
                .replace("]", "")
                .split(",")
                .map((v) => v.trim());
            }



            return (
              <div className="col-md-6 d-flex" key={colIndex}>
                <label className="col-sm-4 col-form-label text-small label-black">
                  {detail.columnLabel.toUpperCase()}
                  {(detail.columnKey === "NOT NULL" ||
                    detail.columnKey === "PRIMARY KEY" ||
                    detail.columnName === "Maker_Remarks") && (
                      <span style={{ color: "red", marginLeft: "4px" }}>*</span>
                    )}
                </label>

                <div className="col-sm-8">

                  {isDropdown ? (
                    /** ✔ RENDER DROPDOWN — user cannot type */
                    <select
                      className="form-control form-control-sm"
                      name={detail.columnName}
                      value={processedFormData[detail.columnName] || ""}
                      onChange={(e) =>
                        handleInputChange(detail.columnName, e.target.value)
                      }
                      disabled={isFieldDisabled(detail.columnName)} // 👈 ADD THIS
                    >
                      <option value="">-- Select --</option>
                      {dropdownOptions.map((opt, index) => (
                        <option key={index} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  ) : (
                    /** ✔ NORMAL INPUT */
                    <input
                      type={
                        detail.columnType.toLowerCase() === "date"
                          ? "date"
                          : detail.columnType.toLowerCase().includes("int") ||
                            detail.columnType.toLowerCase().includes("decimal") ||
                            detail.columnType.toLowerCase().includes("double")
                            ? "number"
                            : "text"
                      }
                      className="form-control form-control-sm"
                      name={detail.columnName}
                      value={processedFormData[detail.columnName] || ""}
                      onChange={(e) =>
                        handleInputChange(detail.columnName, e.target.value)
                      }
                      disabled={isFieldDisabled(detail.columnName)}
                      max={detail.columnType.toLowerCase() === "date" ? today : undefined}
                    />
                  )}

                </div>

              </div>
            );
          })}
        </div>
      ))}

      {/* Submit Button Centered */}
      <div className="form-group row">
        <div className="col-12 d-flex justify-content-center">
          <input
            type="button"
            className="btn btn-sm btn-secondary btn-all-submit"
            value="Submit"
            onClick={handleSubmit}
          />
        </div>
      </div>
    </form>
  );
};




export const OCRFormStructureComponent = ({ paramState, formStructure, formData, handleSubmit, renderInput }) => {
  // Preprocess formData to handle columnActive === "N"
  const processedFormData = preprocessFormData(formStructure.details, formData);

  return (
    <main className="d-flex justify-content-center align-items-center" style={{ width: '100%' }}>
      <div className="col-md-12">
        <div className="card h-100 d-flex flex-column">
          <h6 className="card-header custom-card-header d-flex justify-content-between align-items-center">
            {paramState
              .replace(/_/g, ' ') // Replace underscores with spaces
              .split(' ') // Split by spaces
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
              .join(' ')}{' '}
            Form
          </h6>

          {/*  Scrollable Section Inside Card */}
          <div className="card-body flex-grow-1 overflow-auto" style={{ maxHeight: '60vh' }}>
            <form className="form">
              {formStructure.details
                .filter(detail => detail.columnActive !== "N") // Exclude fields with columnActive set to "N"
                .map((detail, index) => (
                  <div className="form-group row mb-2" key={index}>
                    {/* <label className="col-sm-4 col-form-label text-small label-black">
                      {detail.columnLabel.toUpperCase()}
                    </label> */}
                    <label className="col-sm-4 col-form-label text-small label-black">
                      {detail.columnLabel.toUpperCase()}
                      {(detail.columnKey === 'NOT NULL' || detail.columnKey === 'PRIMARY KEY') && (
                        <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                      )}
                    </label>

                    <div className="col-sm-8 w-50">
                      {detail.columnName === "Remaining_Amount" ? (
                        <input
                          type="number"
                          className="form-control form-control-sm"
                          name={detail.columnName}
                          value={processedFormData[detail.columnName] || ''}
                          readOnly
                        />
                      ) : (
                        renderInput(detail)
                      )}
                    </div>
                  </div>
                ))}

              <div className="form-group row mb-3">
                <div className="w-75 mt-auto d-flex justify-content-center ms-5 "

                >
                  <input
                    type="button"
                    className="btn btn-secondary btn-all-submit me-5"
                    value="Proceed"

                    onClick={handleSubmit}
                  />
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </main>
  );
};


export const Pagination = ({ totalPages, currentPage, paginate }) => {
  const maxVisiblePages = 4; // Number of pages to show at once

  const getPageNumbers = () => {
    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // If total pages are less than or equal to the max visible, show all pages
      pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    } else {
      // Calculate the range of pages to show
      const halfRange = Math.floor(maxVisiblePages / 2);
      let startPage = currentPage - halfRange;
      let endPage = currentPage + halfRange;

      if (startPage <= 1) {
        startPage = 1;
        endPage = maxVisiblePages;
      } else if (endPage >= totalPages) {
        startPage = totalPages - maxVisiblePages + 1;
        endPage = totalPages;
      }

      pages = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

      // Add ellipses
      if (startPage > 1) {
        pages = [1, '...', ...pages];
      }
      if (endPage < totalPages) {
        pages = [...pages, '...', totalPages];
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <>
      {totalPages > 1 && (
        <div className="pagination-container" style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
          <nav aria-label="Page navigation">
            <ul className="pagination">
              {/* Previous button */}
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button className="page-link" style={{ color: '#26b7ec' }} onClick={() => paginate(currentPage - 1)}>
                  Previous
                </button>
              </li>

              {/* Page numbers */}
              {pageNumbers.map((number, index) => (
                number === '...' ? (
                  <li key={index} className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                ) : (
                  <li key={index} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                    <button className="page-link" style={{ color: '#26b7ec' }} onClick={() => paginate(number)}>
                      {number}
                    </button>
                  </li>
                )
              ))}

              {/* Next button */}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button className="page-link" style={{ color: '#26b7ec' }} onClick={() => paginate(currentPage + 1)}>
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </>
  );
};


export const TemplatelistPaginations = ({ currentPage, filteredData, recordsPerPage, paginate }) => {
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  return (
    <div className="d-flex justify-content-center">
      <nav>
        <ul className="pagination">
          {/* Previous Button */}
          <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
          </li>

          {/* First Page */}
          {currentPage > 2 && (
            <>
              <li className="page-item">
                <button
                  onClick={() => paginate(1)}
                  className={`page-link ${currentPage === 1 ? 'active' : ''}`}
                >
                  1
                </button>
              </li>
              {currentPage > 3 && (
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              )}
            </>
          )}

          {/* Visible Page Numbers */}
          {[...Array(totalPages).keys()]
            .slice(
              Math.max(0, currentPage - 2),
              Math.min(totalPages, currentPage + 1)
            )
            .map((number) => (
              <li key={number + 1} className="page-item">
                <button
                  onClick={() => paginate(number + 1)}
                  className={`page-link ${currentPage === number + 1 ? 'active' : ''}`}
                >
                  {number + 1}
                </button>
              </li>
            ))}

          {/* Ellipsis and Last Page */}
          {currentPage + 1 < totalPages && (
            <>
              {currentPage + 2 < totalPages && (
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              )}
              <li className="page-item">
                <button
                  onClick={() => paginate(totalPages)}
                  className="page-link"
                >
                  {totalPages}
                </button>
              </li>
            </>
          )}

          {/* Next Button */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
            <button
              className="page-link"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export const TemplateReportStructure = ({ loading, error, currentItems, columnsToDisplay }) => {
  // Helper function to get value case-insensitively
  const getCaseInsensitiveValue = (item, columnName) => {
    const lowerColumnName = columnName.toLowerCase();
    const actualKey = Object.keys(item).find(key => key.toLowerCase() === lowerColumnName);
    return actualKey ? item[actualKey] : item[columnName];
  };

  return (
    <div className="col">
      {loading ? (
        <div className="text-center mt-4">

          <TableLoading />
        </div>
      ) : error ? (
        <p className="text-center">{error}</p>
      ) : currentItems.length > 0 ? (
        <div className="table-on-homepage-only">
          <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
            <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
              <thead className="sticky-header">
                <tr>
                  {columnsToDisplay.map((key, index) => (
                    key !== 'ROW_ID' && (
                      <th scope="col" key={index} style={TableHeader1}>
                        {key.charAt(0).toUpperCase() + key.slice(1)}
                      </th>
                    )
                  ))}
                </tr>
              </thead>
              <tbody style={tbodyStyles2}>
                {currentItems.map((item, rowIndex) => (
                  <tr key={rowIndex} style={{ lineHeight: '25px' }}>
                    {columnsToDisplay.map((key, colIndex) => (
                      key !== 'ROW_ID' && (
                        <td key={colIndex} style={
                          tableCellStyle2(rowIndex)
                        }>
                          {(() => {
                            const value = getCaseInsensitiveValue(item, key);
                            return value === null || value === '\\N' ? '' : String(value);
                          })()}

                        </td>
                      )
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div>
          <div className="text-center"></div>
          <div className="d-flex justify-content-center align-items-center" style={{ marginTop: '10px' }}>
            <p>Nothing Pending for Modification</p>
          </div>
        </div>
      )}
    </div>
  );
};

export const TemplateReportStructure1 = ({
  loading,
  error,
  currentItems,
  columnsToDisplay,
  sortConfig,
  requestSort
}) => {

  const getSortIcon = (key) => {
    if (sortConfig?.key === key) {
      return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
    }
    return faSort;
  };

  // Helper function to get value case-insensitively
  const getCaseInsensitiveValue = (item, columnName) => {
    const lowerColumnName = columnName.toLowerCase();
    const actualKey = Object.keys(item).find(
      key => key.toLowerCase() === lowerColumnName
    );
    return actualKey ? item[actualKey] : item[columnName];
  };

  return (
    <div className="col">
      {loading ? (
        <div className="text-center mt-4">
          <TableLoading />
        </div>
      ) : error ? (
        <p className="text-center">{error}</p>
      ) : currentItems.length > 0 ? (
        <div className="table-on-homepage-only">
          <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
            <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
              <thead className="sticky-header">
                <tr>
                  {columnsToDisplay.map((key, index) => (
                    key !== 'ROW_ID' && (
                      <th
                        scope="col"
                        key={index}
                        style={{ ...TableHeader1, cursor: 'pointer', whiteSpace: 'nowrap' }}
                        onClick={() => requestSort(key)}
                      >
                        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                          {key.charAt(0).toUpperCase() + key.slice(1)}
                          <FontAwesomeIcon
                            icon={getSortIcon(key)}
                            style={{ marginLeft: '6px' }}
                          />
                        </span>
                      </th>
                    )
                  ))}
                </tr>
              </thead>

              <tbody style={tbodyStyles2}>
                {currentItems.map((item, rowIndex) => (
                  <tr key={rowIndex} style={{ lineHeight: '25px' }}>
                    {columnsToDisplay.map((key, colIndex) => (
                      key !== 'ROW_ID' && (
                        <td
                          key={colIndex}
                          style={tableCellStyle2(rowIndex)}
                        >
                          {(() => {
                            const value = getCaseInsensitiveValue(item, key);
                            return value === null || value === '\\N'
                              ? ''
                              : String(value);
                          })()}
                        </td>
                      )
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div>
          <div className="text-center"></div>
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ marginTop: '10px' }}
          >
            <p>Nothing Pending for Modification</p>
          </div>
        </div>
      )}
    </div>
  );
};

// ==================================TemplatetablelistTableStructure===================================

export const TemplatetablelistTableStructure = ({ loading, error, currentItems, columnsToDisplay, handleEdit, handleDelete, isLiveTable }) => {
  return (
    <div className="col">
      {loading ? (
        <div className="text-center mt-4">

          <TableLoading />
        </div>
      ) : error ? (
        <p className="text-center">{error}</p>
      ) : currentItems.length > 0 ? (
        <div className="table-on-homepage-only">
          <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
            <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
              <thead className="sticky-header">
                <tr>
                  {columnsToDisplay.map((key, index) => (
                    key !== 'rowId' && key !== 'created_dt' && key !== 'created_by' && key !== 'active_yn' &&
                    key !== 'modified_by' && key !== 'modified_dt' && (
                      <th scope="col" key={index} style={TableHeader1}>
                        {key.charAt(0).toUpperCase() + key.slice(1)}
                      </th>
                    )
                  ))}
                  <th scope="col" style={TableHeader1}>Actions</th>
                </tr>
              </thead>
              <tbody style={tbodyStyles2}>
                {currentItems.map((item, rowIndex) => (
                  <tr key={rowIndex} style={{ lineHeight: '25px' }}>
                    {columnsToDisplay.map((key, colIndex) => (
                      key !== 'rowId' && key !== 'created_dt' && key !== 'created_by' && key !== 'active_yn' &&
                      key !== 'modified_by' && key !== 'modified_dt' && (
                        <td key={colIndex} style={
                          tableCellStyle2(rowIndex)
                        }>
                          {item[key] === null || item[key] === '\\N' ? '' : item[key]}
                        </td>
                      )
                    ))}
                    <td style={

                      tableCellStyle2(rowIndex)
                    }>

                      <button
                        type="button"
                        className="btn btn-light btn-sm "
                        data-toggle="tooltip"
                        data-placement="Left"
                        title="Click to Edit"
                        style={{
                          marginLeft: '15px',
                          // padding: '2px',
                          // fontSize: '10px',
                          border: 'none',
                          backgroundColor: 'transparent',
                        }}
                        onClick={() => handleEdit(item.rowId)}
                      >
                        {/* Icon with green fill and white border */}
                        <link
                          href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                          rel="stylesheet"
                        />
                        <i
                          className="bi bi-pencil"
                          style={{
                            ...EditIcon,
                            marginRight: '10px',
                            lineHeight: '10px'
                          }}
                        ></i>
                      </button>
                      {!isLiveTable && (

                        <button
                          type="button"
                          // className="btn btn-light btn-sm"
                          className="btn btn-light btn-sm"

                          data-toggle="tooltip"
                          data-placement="Left"
                          title="Click to Delete"
                          style={{
                            border: 'none',            // No border for the button
                            backgroundColor: 'transparent', // Transparent background for the button
                          }}
                          onClick={() => handleDelete(item.rowId)}
                        >

                          <i
                            className="bi bi-trash"
                            style={{
                              ...DeleteIcon,
                              marginRight: '5px',
                              lineHeight: '10px',
                              // Icon size


                            }}
                          ></i>
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div>
          <div className="text-center"></div>
          <div className="d-flex justify-content-center align-items-center" style={{ marginTop: '10px' }}>
            <p>Nothing Pending for Modification</p>
          </div>
        </div>
      )}
    </div>
  );
};

export const TemplatetablelistTableStructure1 = ({
  loading,
  error,
  currentItems,
  columnsToDisplay,
  columnDetails = [],
  handleEditBDM,
  handleDelete,
  handleInputChange,
  handleSave,
  handleCancel,
  editingIndexBDm,
  primaryKeyFields = [],
  isLiveTable
}) => {


  const disabledColumnsOnEdit = [
    "criticality",
    "frequency",
    "ownership",
    "risk_area",
    "risk_indicator",
    "definition"
  ];

  // ✅ SAME dropdown logic as FormStructureComponent
  const getDropdownOptions = (columnName) => {
    const col = columnDetails.find(d => d.columnName === columnName);

    if (
      col?.columnFunction &&
      col.columnFunction.startsWith("dropdown:")
    ) {
      return col.columnFunction
        .replace("dropdown:", "")
        .replace("[", "")
        .replace("]", "")
        .split(",")
        .map(v => v.trim());
    }
    return null;
  };

  return (
    <div className="col">
      {loading ? (
        <div className="text-center mt-4">
          <TableLoading />
        </div>
      ) : error ? (
        <p className="text-center">{error}</p>
      ) : currentItems.length > 0 ? (
        <div className="table-on-homepage-only">
          <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
            <table className={`table table-bordered table-hover text-center ${tableStyles.customScrollTable}`}>
              <thead className="sticky-header">
                <tr>
                  {columnsToDisplay.map((key, index) =>
                    !['rowId', 'created_dt', 'created_by', 'active_yn', 'modified_by', 'modified_dt'].includes(key) ? (
                      <th scope="col" key={index} style={TableHeader1}>
                        {key.charAt(0).toUpperCase() + key.slice(1)}
                      </th>
                    ) : null
                  )}
                  <th scope="col" style={TableHeader1}>Actions</th>
                </tr>
              </thead>

              <tbody style={tbodyStyles2}>
                {currentItems.map((item, rowIndex) => (
                  <tr key={rowIndex}>
                    {columnsToDisplay.map((key, colIndex) => {
                      if (['rowId', 'created_dt', 'created_by', 'active_yn', 'modified_by', 'modified_dt'].includes(key)) {
                        return null;
                      }

                      const normalizedValue =
                        item[key] === null ||
                          item[key] === '\\N' ||
                          item[key] === undefined
                          ? ''
                          : String(item[key]).trim();

                      const dropdownOptions = getDropdownOptions(key);

                      const safeDropdownOptions = dropdownOptions
                        ? dropdownOptions.includes(normalizedValue)
                          ? dropdownOptions
                          : [normalizedValue, ...dropdownOptions]
                        : null;

                      return (
                        <td
                          key={colIndex}
                          style={{
                            ...tableCellStyle2(rowIndex),
                            backgroundColor: editingIndexBDm === item.rowId ? '#e6f7ff' : '',
                          }}
                        >
                          {editingIndexBDm === item.rowId ? (
                            dropdownOptions ? (
                              /** ✅ DROPDOWN FIELD */
                              <select
                                className="form-control form-control-sm"
                                style={{ backgroundColor: '#e6f7ff' }}
                                value={item[key] ?? ""}
                                onChange={(e) => handleInputChange(e, key, rowIndex)}
                                // disabled={primaryKeyFields.includes(key)}
                                disabled={
                                  primaryKeyFields.includes(key) ||
                                  disabledColumnsOnEdit.includes(key)
                                }
                              >
                                <option value="">-- Select --</option>
                                {dropdownOptions.map((opt, idx) => (
                                  <option key={idx} value={opt}>
                                    {opt}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              /** ✅ NORMAL INPUT */
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                style={{ backgroundColor: '#e6f7ff' }}
                                value={item[key] === null || item[key] === '\\N' ? '' : item[key]}
                                onChange={(e) => handleInputChange(e, key, rowIndex)}
                                disabled={
                                  primaryKeyFields.includes(key) ||
                                  disabledColumnsOnEdit.includes(key)
                                }
                              />
                            )
                          ) : (
                            item[key] === null || item[key] === '\\N' ? '' : item[key]
                          )}
                        </td>
                      );
                    })}

                    <td style={tableCellStyle2(rowIndex)}>
                      {editingIndexBDm === item.rowId ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-outline-success btn-sm me-2"
                            title="Save"
                            onClick={() => handleSave(rowIndex)}
                          >
                            <i className="bi bi-save me-1"></i> Save
                          </button>

                          <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm"
                            title="Cancel"
                            onClick={handleCancel}
                          >
                            <i className="bi bi-x-circle me-1"></i> Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            type="button"
                            className="btn btn-light btn-sm"
                            title="Edit"
                            onClick={() => handleEditBDM(item.rowId)}
                            style={{ border: 'none', backgroundColor: 'transparent', marginLeft: '15px' }}
                          >
                            <i className="bi bi-pencil"></i>
                          </button>

                          {!isLiveTable && (
                            <button
                              type="button"
                              data-toggle="tooltip"
                              data-placement="Left"
                              title="Click to Delete"
                              className="btn btn-light btn-sm"
                              onClick={() => handleDelete(item.rowId)}
                              style={{ border: 'none', backgroundColor: 'transparent' }}
                            >
                              <i
                                className="bi bi-trash"
                                style={{
                                  ...DeleteIcon,
                                  marginRight: '5px',
                                  lineHeight: '10px',

                                }}
                              ></i>
                            </button>
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div>
          <div className="text-center"></div>
          <div className="d-flex justify-content-center align-items-center" style={{ marginTop: '10px' }}>
            <p>Nothing Pending for Modification</p>
          </div>
        </div>
      )}
    </div>
  );
};



// utils.js
export const hasRejectedRecordsHide = (tableData) => {
  return tableData.some(item =>
    item.Rejected_Reason === "\\N" || item.Rejected_Reason === "\N" || item.Rejected_Reason === "NULL"
  );
};

export const RejectedRecordsTable = ({
  hasRejectedRecords,
  tableColumns,
  currentRecords,
  handleReject,
  hiddenColumns, // New prop for hidden columns
  setHiddenColumns, // New prop to update hidden columns
  selectedColumn
}) => {

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  // const [Updatedcolumns, setUpdatedcolumns] = useState('');
  const [Updatedcolumns, setUpdatedcolumns] = useState([]); // Changed to an array


  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const dropdownOptions = [
    { key: 'modified_by', label: 'Modified By' },
    { key: 'modified_dt', label: 'Modified Date' },
    { key: 'created_by', label: 'Created By' },
    { key: 'created_dt', label: 'Created Date' },
  ];
  const handleCheckboxChange = (key) => {
    setUpdatedcolumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    );

  };

  return (
    <div
      style={{
        maxHeight: 'calc(109vh - 267px)', // Maximum height for the table container
        overflowY: 'auto',                // Enable vertical scrolling
        overflowX: 'auto',                // Enable horizontal scrolling
        marginTop: '10px',                // Top margin
      }}
    >
      <table
        className={tableClassStyle.className}
        style={tableClassStyle.style}
      >
        {hasRejectedRecords && (
          <thead className="sticky-top" style={TableHeader1}>
            <tr>
              {tableColumns.map((key, index) => (
                !['rowId', 'Rejected_Reason', 'active_yn'].includes(key) &&

                !dropdownOptions.some((option) => option.key === key) && (
                  // <th scope="col" key={index} style={TableHeader1}>{key}</th>
                  <th scope="col" key={index} style={TableHeader1}>
                    {key}
                  </th>
                )
              ))}
              {
                Updatedcolumns.map((column) => (
                  <th key={column} scope="col" style={TableHeader1}>
                    {dropdownOptions.find((option) => option.key === column)?.label}
                  </th>
                ))}

              <th scope="col" style={{ position: 'relative' }}>
                status
                <div
                  ref={dropdownRef}
                  style={{
                    position: 'relative',
                    display: 'inline-block',
                    marginLeft: '10px',
                  }}
                >

                  <button
                    onClick={toggleDropdown}
                    style={{
                      color: 'black',
                      border: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                    }}
                  >
                    <i className="bi bi-caret-down-square" style={{ color: 'black' }}></i>

                  </button>

                  {showDropdown && (
                    <div
                      style={{
                        position: 'fixed',
                        top: '151px',
                        right: '10px',
                        backgroundColor: 'white',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        zIndex: '1000',
                        borderRadius: '4px',
                        minWidth: '150px',
                        color: 'black',
                        padding: '5px',
                      }}
                    >
                      {dropdownOptions.map((option) => (
                        <div
                          key={option.key}
                          style={{
                            display: 'flex',
                            alignItems: 'left',
                            cursor: 'pointer',
                            transition: 'background 0.2s',
                            padding: '1px 5px',
                            fontWeight: 'normal',
                            fontSize: '14px',
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={Updatedcolumns.includes(option.key)}
                            onChange={() => handleCheckboxChange(option.key)}
                            style={{ marginRight: '8px' }}
                            onMouseEnter={(e) => (e.target.style.background = '#f5f5f5')}
                            onMouseLeave={(e) => (e.target.style.background = 'transparent')}

                          />
                          {option.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </th>
            </tr>
          </thead>
          // hiddenColumns

        )}
        <tbody style={tbodyStyles}>
          {currentRecords.map((item, rowIndex) =>
            (item.Rejected_Reason === "\\N" ||
              item.Rejected_Reason === "\N" ||
              item.Rejected_Reason === "NULL") && (
              <tr key={rowIndex} style={{
                boxShadow: rowIndex % 2 === 0 ? '2px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 0px 0px rgba(0, 0, 0, 0.2)',
                border: '1px solid black',
                padding: '5px',
                height: '10px',
                lineHeight: '30px'
              }}>
                {Object.keys(item).map((key, colIndex) => (
                  !['rowId', 'Rejected_Reason', 'active_yn'].includes(key) &&

                  !dropdownOptions.some((option) => option.key === key) && (
                    <td key={colIndex} style={tableCellStyle(rowIndex)}>{item[key]}</td>
                  )
                ))}


                {Updatedcolumns.length > 0 &&
                  Updatedcolumns.map((column) => (
                    <td key={column} style={tableCellStyle(rowIndex)}>
                      {item[column] || 'N/A'}
                    </td>
                  ))}
                <td style={tableCellStyle1(rowIndex)}>
                  <button
                    type="button"
                    className="btn btn-light btn-sm"
                    data-toggle="tooltip"
                    data-placement="Left"
                    title="Click to Reject"
                    style={{
                      marginLeft: '10px',
                      padding: '2px',
                      fontSize: '10px',
                      border: 'none',
                      backgroundColor: 'transparent',
                    }}
                    onClick={() => handleReject(item.rowId)}
                  >
                    <link
                      href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                      rel="stylesheet"
                    />
                    <i
                      className="bi bi-x-circle"
                      style={{
                        ...RejectIcon
                      }}
                    ></i>
                  </button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};




// ============================================================================================
export const BulkApproveButton = ({
  currentPage,
  totalPages,
  searchTerm,
  handleApproveBulk,
  handleBulkReject,
  selectedRowIdToSend,
  selectedRowIds // Add selectedRowIds as a prop
}) => {
  // Show buttons on all pages if items are selected, otherwise only on last page with no search
  const shouldShowButtons =
    selectedRowIds.length > 1 ||
    (currentPage === totalPages && searchTerm.trim() === '');

  if (!shouldShowButtons) return null;

  return (
    <div className="text-center" style={{ marginTop: '10px' }}>
      <button
        type="button"
        className="btn btn-light btn-sm custom-btn"
        data-toggle="tooltip"
        data-placement="Left"
        title="Click to Approve"
        style={{ ...Aprrovecolor, color: "white", marginRight: '10px' }}
        onClick={() => handleApproveBulk(selectedRowIdToSend)}
        disabled={selectedRowIds.length <= 1} // Disable if no selections
      >
        Approve
      </button>
      <button
        type="button"
        className="btn btn-light btn-sm custom-btn"
        data-toggle="tooltip"
        data-placement="Left"
        title="Click to Reject"
        style={{
          ...Rejectcolor,
          color: 'white',
          marginLeft: '10px'
        }}
        onClick={() => handleBulkReject(selectedRowIdToSend)}
        disabled={selectedRowIds.length <= 1} // Disable if no selections
      >
        Reject
      </button>
    </div>
  );
};

export const BulkApproveButtonRetieve = ({ currentPage, totalPages, searchTerm, handleApproveBulk, handleBulkReject }) => {
  return (
    currentPage === totalPages && searchTerm.trim() === '' && (
      <div className="text-center" style={{ marginTop: '10px' }}>
        <button
          type="button"
          className="btn btn-light btn-sm custom-btn"
          data-toggle="tooltip"
          data-placement="Left"
          title="Click to Approve"
          style={{ ...Aprrovecolor, color: "white", marginRight: '10px' }}
          onClick={handleApproveBulk}
        >
          Approve
        </button>
        <button
          type="button"
          // className="btn btn-light btn-sm"
          className="btn btn-light btn-sm custom-btn"

          data-toggle="tooltip"
          data-placement="Left"
          title="Click to Reject"
          style={
            {
              ...Rejectcolor, // Button background color
              color: 'white',             // Button text color
              marginLeft: '10px',         // Left margin
              // No border
            }
          }
          onClick={handleBulkReject}
        >
          Reject
        </button>

      </div>
    )
  );
};

export const BulkButton = ({ currentPage, totalPages, searchTerm, handleApprove }) => {
  return (
    currentPage === totalPages && searchTerm.trim() === '' && (
      <div className="text-center" style={{ marginTop: '10px' }}>
        <button
          type="button"
          className="btn btn-light btn-sm custom-btn"
          data-toggle="tooltip"
          data-placement="Left"
          title="Click to Approve"
          style={{ backgroundColor: "#26b7ec", color: "black", marginRight: '10px' }}
          onClick={handleApprove}
        >
          Approve
        </button>
      </div>
    )
  );
};

export const RenderTable = ({
  isLoading,
  error,
  currentRecords,
  tableData,
  tableColumns,
  handleApprove,
  handleReject,
  totalPages,
  currentPage,
  paginate
}) => {

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [Updatedcolumns, setUpdatedcolumns] = useState('');


  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (isLoading) {
    return <TableLoading />;
  }

  if (error) {
    return <p>{error}</p>; // Show error message
  }

  if (currentRecords.length === 0) {
    return <p>Nothing Pending for Review current</p>;
  }

  const hasRecords = tableData.length > 0;
  const hasRejectedRecords = tableData.some(item =>
    item.Rejected_Reason === "Ready for validation. (updated)" ||
    item.Rejected_Reason === "\\N"
  );

  if (!hasRecords || !hasRejectedRecords) {
    return <p>Nothing Pending for Review has </p>;
  }

  const dropdownOptions = [
    { key: 'modified_by', label: 'Modified By' },
    { key: 'modified_dt', label: 'Modified Date' },
    { key: 'created_by', label: 'Created By' },
    { key: 'created_dt', label: 'Created Date' },
    { key: 'approved_dt', label: 'Approved Date' },
    { key: 'approved_by', label: 'Approved By' },
  ];


  const handleCheckboxChange = (key) => {
    const updated = Updatedcolumns.includes(key)
      ? Updatedcolumns.filter((col) => col !== key)
      : [...Updatedcolumns, key];

    setUpdatedcolumns(updated);
    localStorage.setItem('demCheckerRetrieveColumns', JSON.stringify(updated)); // Save to localStorage
  };


  return (
    <div>
      <div style={{ maxHeight: 'calc(100vh - 265px)', overflowY: 'auto', overflowX: 'auto', marginTop: '10px' }}>
        <table className={tableClassStyle.className} style={tableClassStyle.style}>
          {hasRejectedRecords && (
            <thead className='sticky-top' style={TableHeader1}>
              <tr>
                {tableColumns.map((key, index) => (
                  !['rowId', 'Rejected_Reason', 'flag', 'dataModel'].includes(key) &&

                  !dropdownOptions.some((option) => option.key === key) && (
                    <th scope="col" style={TableHeader1} key={index}>{key}</th>
                  )
                ))}
                {Updatedcolumns.length > 0 &&
                  Updatedcolumns.map((column) => (
                    <th key={column} scope="col" style={TableHeader1}>
                      {dropdownOptions.find((option) => option.key === column)?.label}
                    </th>
                  ))}
                <th scope="col" style={{ position: 'relative' }}>
                  Action
                  <div
                    ref={dropdownRef}
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      marginLeft: '10px',
                    }}
                  >
                    <button
                      onClick={toggleDropdown}
                      style={{
                        color: 'black',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                      }}
                    >
                      <i className="bi bi-caret-down-square" style={{ color: 'black' }}></i>

                    </button>

                    {showDropdown && (
                      <div
                        style={{
                          position: 'fixed',
                          top: '151px',
                          right: '10px',
                          backgroundColor: 'white',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                          zIndex: '1000',
                          borderRadius: '4px',
                          minWidth: '150px',
                          color: 'black',
                          padding: '5px',
                        }}
                      >
                        {dropdownOptions.map((option) => (
                          <div
                            key={option.key}
                            style={{
                              display: 'flex',
                              alignItems: 'left',
                              cursor: 'pointer',
                              transition: 'background 0.2s',
                              padding: '3px 5px',
                              fontWeight: 'normal',
                              fontSize: '14px',
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={Updatedcolumns.includes(option.key)}
                              onChange={() => handleCheckboxChange(option.key)}
                              style={{ marginRight: '8px' }}
                              onMouseEnter={(e) => (e.target.style.background = '#f5f5f5')}
                              onMouseLeave={(e) => (e.target.style.background = 'transparent')}


                            />
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </th>
              </tr>
            </thead>
          )}
          <tbody style={tbodyStyles}>
            {currentRecords.map((item, rowIndex) => (
              (
                // <tr key={rowIndex} style={{ boxShadow: rowIndex % 2 === 0 ? '2px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 0px 0px rgba(0, 0, 0, 0.2)' }}>
                <tr key={rowIndex}

                  style={{
                    boxShadow: rowIndex % 2 === 0 ? '2px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 0px 0px rgba(0, 0, 0, 0.2)',
                    padding: '5px',
                    height: '10px',
                    lineHeight: '30px'
                  }}
                >
                  {Object.keys(item).map((key, colIndex) => (
                    // key !== 'rowId' && key !== 'rejectedReason' && key !== 'flag' && (

                    !['rowId', 'Rejected_Reason', 'flag', 'dataModel'].includes(key) &&


                    !dropdownOptions.some((option) => option.key === key) && (
                      <td key={colIndex} style={

                        tableCellStyle(rowIndex)
                      }>{item[key]}</td>
                    )
                  ))}

                  {Updatedcolumns.length > 0 &&
                    Updatedcolumns.map((column) => (
                      <td key={column} style={tableCellStyle(rowIndex)}>
                        {item[column] || 'N/A'}
                      </td>
                    ))}
                  <td>

                    <button
                      type="button"
                      className="btn btn-light btn-sm "
                      data-toggle="tooltip"
                      data-placement="Left"
                      title="Click to Approve"
                      style={{
                        marginLeft: '15px',
                        border: 'none',
                        backgroundColor: 'transparent',
                      }}
                      onClick={() => handleApprove(item.rowId)}
                    >
                      <link
                        href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                        rel="stylesheet"
                      />
                      <i
                        className="bi bi-check-circle"
                        style={{
                          ...ApporveIcon,
                          marginRight: '10px'
                        }}
                      ></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-light btn-sm"
                      data-toggle="tooltip"
                      data-placement="Left"
                      title="Click to Reject"
                      style={{

                        border: 'none',            // No border for the button
                        backgroundColor: 'transparent', // Transparent background for the button
                      }}
                      onClick={() => handleReject(item.rowId)}
                    >
                      <i
                        className="bi bi-x-circle"
                        style={{
                          ...RejectIcon,
                          marginRight: '5px',
                        }}
                      ></i>
                    </button>
                  </td>

                </tr>
              )))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />
    </div>
  );
};

// *********************************************************************************************************************************


// **********************************************************************************************************************************
const filterRejectedRecords = (data) => {
  return data.filter(item => (
    item.Rejected_Reason !== "Ready for validation. (updated)" &&
    item.Rejected_Reason !== "\\N" ||
    item.Rejected_Reason !== "" || item.Rejected_Reason !== "\N") && (
      item.active_yn !== 'N' && item.active_yn !== "N"
    ));
};


// =======================================================================================================

export const NoRecordsModal = ({ show, handleClose }) => (
  <Modal show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>No Records Found</Modal.Title>
    </Modal.Header>
    <Modal.Body>No records match your search criteria.</Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handleClose}>
        OK
      </Button>
    </Modal.Footer>
  </Modal>
);

// =====================================List of tables Common For All = ========================================


export const TableListComponent = ({ currentRecords, selectedTable, handleTableClick, getTooltipTitle }) => {
  return (
    <table className="table">
      <tbody>
        {currentRecords.map((tableName, index) => (
          <tr
            key={index}
            className={selectedTable === tableName ? 'list-table-item selected' : 'list-table-item'}
          >
            <td style={ListofTableFontsize}>
              <a
                href="#"
                className="link-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title={getTooltipTitle(tableName)}
                onClick={() => handleTableClick(tableName)}
              >
                {tableName.charAt(0).toUpperCase() + tableName.slice(1)}
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};


export const TableListComponentChecker = ({
  currentRecords,
  selectedTable,
  handleTableClick,
  getTooltipTitle,
  tableNames, // Actual table names
  displayTableNames, // Formatted display labels
}) => {
  return (
    <table className="table table-striped table-bordered">
      <tbody>
        {currentRecords.map((record, index) => {
          // Access and format the Table_name
          const tableName = record.Table_name;

          // Apply the transformation
          const formattedTableName = String(tableName)
            .replace(/_/g, ' ') // Replace underscores with spaces
            .split(' ') // Split by spaces
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(' '); // Join the words back with spaces

          return (
            <tr
              key={index}
              className={selectedTable === formattedTableName ? 'list-table-item selected' : 'list-table-item'}
            >
              <td style={ListofTableFontsize}>
                <a
                  href="#"
                  className="link-info"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title={getTooltipTitle(formattedTableName)}
                  onClick={() => handleTableClick(tableName)}
                >
                  {formattedTableName}
                </a>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export const TableListComponent1 = ({ currentRecords, selectedTable, handleTableClick, getTooltipTitle }) => {
  return (
    <table className="table table-striped table-bordered">
      <tbody>
        {currentRecords.map((tableName) => (
          <tr
            key={tableName}
            className={selectedTable === tableName ? 'list-table-item selected' : 'list-table-item'}
          >
            <td style={ListofTableFontsize}>
              <a
                href="#"
                className="link-info"
                data-toggle="tooltip"
                data-placement="bottom"
                title={getTooltipTitle(tableName)}
                onClick={() => handleTableClick(tableName)}
              >
                {tableName.charAt(0).toUpperCase() + tableName.slice(1)}
              </a>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

//display with without underscore and giving camelcase
export const TableListComponent2 = ({
  currentRecords,
  selectedTable,
  handleTableClick,
  getTooltipTitle,
  tableNames, // Actual table names
  displayTableNames // Formatted display labels (no longer needed)
}) => {
  return (
    <table className="table table-striped table-bordered">
      <tbody>
        {currentRecords.map((tableName) => {
          // Apply the transformation to format the table name
          const formattedTableName = tableName
            .replace(/_/g, ' ') // Replace underscores with spaces
            .split(' ') // Split by spaces
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(' '); // Join the words back with spaces

          return (
            <tr
              key={tableName}
              className={selectedTable === tableName ? 'list-table-item selected' : 'list-table-item'}
            >
              <td style={ListofTableFontsize}>
                <a
                  href="#"
                  className="link-info"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title={getTooltipTitle(formattedTableName)} // Tooltip shows actual table name
                  onClick={() => handleTableClick(tableName)} // Pass actual table name on click
                >
                  {formattedTableName} {/* Display the formatted label */}
                </a>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};


export const ReviewTableList = ({ currentRecords, handleTableClick }) => {
  const formatTableName = (name) => {
    return name
      ?.replace(/_/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ') || '';
  };

  return (
    <table className="table table-bordered m-auto table-shadow mt-2">
      <thead>
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Table Name</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        {currentRecords.length === 0 ? (
          <tr>
            <td colSpan="3" className="text-center">No data found.</td>
          </tr>
        ) : (
          currentRecords.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{formatTableName(item.tableNameWithoutPrefix)}</td>
              <td>
                <button
                  className="btn btn-sm btn-Review rounded-0"
                  onClick={() => handleTableClick(item)}
                >
                  Review
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};
export const ComparisonTableList = ({ currentRecords, handleTableClick }) => {
  const formatTableName = (name) => {
    return name
      ?.replace(/_/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ') || '';
  };

  return (
    <table className="table table-bordered m-auto table-shadow">
      <thead>
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Table Name</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        {currentRecords.length === 0 ? (
          <tr>
            <td colSpan="3" className="text-center">No table found.</td>
          </tr>
        ) : (
          currentRecords.map((tableName, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{formatTableName(tableName)}</td>
              <td>
                <button
                  className="btn btn-sm btn-Review rounded-0"
                  onClick={() => handleTableClick(tableName)}
                >
                  View
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export const ModifyTableList = ({ currentRecords, handleTableClick, currentPage, recordsPerPage }) => {
  const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  return (
    <table className="table table-bordered m-auto table-shadow mt-2">
      <thead>
        <tr>
          <th scope="col">S.No.</th>
          <th scope="col">Table Name</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        {currentRecords.length === 0 ? (
          <tr>
            <td colSpan="3" className="text-center">No data found.</td>
          </tr>
        ) : (
          currentRecords.map((item, index) => {
            const serialNumber = (currentPage - 1) * recordsPerPage + index + 1;
            return (
              <tr key={index}>
                <td>{serialNumber}</td>
                <td>{capitalizeFirstLetter(item.tableNameWithoutPrefix)}</td> {/* Display the cleaned table name */}
                <td>
                  <button
                    className="btn btn-sm btn-Modify rounded-0"
                    onClick={() => handleTableClick(item.tableNameWithoutPrefix, item.isRetrieve)}
                  >
                    Modify
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};


export const TableListComponentModify = ({ currentRecords, handleTableClick, getTooltipTitle }) => {
  return (
    <table
      className="table table-striped table-bordered"
      style={{ borderCollapse: 'collapse', border: '1px solid black', margin: 'auto' }}
    >
      <thead>
        <tr>
          <th scope="col" style={{ border: '1px solid black', textAlign: 'center' }}>TableName</th>
          <th scope="col" style={{ border: '1px solid black', textAlign: 'center' }}>Reason</th>
        </tr>
      </thead>
      <tbody>
        {currentRecords.map((record, index) => {
          const { Table_name, Rejected_Reason } = record;
          const tableName = record.Table_name || 'Unknown'; // Default to 'Unknown' if undefined
          const rejectedReason = record.Rejected_Reason || 'No reason'; // Default to 'No reason' if undefined

          // Apply the transformation to format the table name
          const formattedTableName = tableName
            .replace(/_/g, ' ') // Replace underscores with spaces
            .split(' ') // Split by spaces
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(' '); // Join the words back with spaces

          return (
            <tr key={index} className="list-table-item">
              <td style={{ whiteSpace: 'nowrap' }}>
                <a
                  href="#"
                  className="text-decoration-none"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title={getTooltipTitle(formattedTableName)} // Tooltip shows formatted table name
                  onClick={() => handleTableClick(tableName)} // Pass actual table name on click
                >
                  {formattedTableName} {/* Display the formatted label */}
                </a>
              </td>
              <td>{rejectedReason}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export const TableListComponentModify1 = ({ currentRecords, handleTableClick, getTooltipTitle, selectedTable }) => {
  return (
    <table className="table table-striped table-bordered" style={{ borderCollapse: 'collapse', border: '1px solid black', margin: 'auto' }}>
      <thead>
        <tr>
          <th scope="col" style={{ border: '1px solid black', textAlign: 'center' }}>TableName</th>
          <th scope="col" style={{ border: '1px solid black', textAlign: 'center' }}>Reason</th>
        </tr>
      </thead>
      <tbody>
        {currentRecords.map((record) => {
          const tableName = record.Table_name || 'Unknown'; // Default to 'Unknown' if undefined
          const rejectedReason = record.Rejected_Reason || 'No reason'; // Default to 'No reason' if undefined

          return (
            <tr key={tableName} className="list-table-item">
              <td>

                <a
                  href="#"
                  // className="link-info"
                  className="text-decoration-none"
                  // style={{ textDecoration: 'underline', color: '#007bff', cursor: 'pointer' }}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title={getTooltipTitle(tableName)}
                  onClick={() => handleTableClick(tableName)}
                >
                  {tableName.charAt(0).toUpperCase() + tableName.slice(1)}
                </a>
              </td>
              <td>{rejectedReason}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export const PaginationComponent = ({
  currentPage,
  totalPages,
  paginate,
  recordsPerPage,
  tableNames,
}) => {
  const maxVisiblePages = 4; // Number of pages to show at once

  // Function to calculate the visible page numbers without duplicates
  const getPageNumbers = () => {
    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Show all pages if total pages are less than or equal to max visible pages
      pages = Array.from({ length: totalPages }, (_, index) => index + 1);
    } else {
      const halfRange = Math.floor(maxVisiblePages / 2);
      let startPage = currentPage - halfRange;
      let endPage = currentPage + halfRange;

      if (startPage < 1) {
        startPage = 1;
        endPage = maxVisiblePages;
      } else if (endPage > totalPages) {
        startPage = totalPages - maxVisiblePages + 1;
        endPage = totalPages;
      }

      pages = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);

      // Add ellipses only if there's a gap between the current range and start/end
      if (startPage > 1) {
        pages = [1, '...', ...pages];
      }
      if (endPage < totalPages) {
        pages = [...pages, '...', totalPages];
      }
    }

    // Ensure unique values in pages array
    return [...new Set(pages)];
  };

  const pageNumbers = getPageNumbers();

  return (
    <>
      {tableNames.length > recordsPerPage && (
        <div className="custom-card-footer">
          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-center">
              {/* Previous button */}
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  style={{ color: '#26b7ec' }}
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
              </li>

              {/* Page numbers with ellipses */}
              {pageNumbers.map((pageNumber, index) => (
                pageNumber === '...' ? (
                  <li key={`ellipsis-${index}`} className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                ) : (
                  <li
                    key={pageNumber}
                    className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}
                  >
                    <button
                      className="page-link"
                      style={{ color: '#26b7ec' }}
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                )
              ))}

              {/* Next button */}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <button
                  className="page-link"
                  style={{ color: '#26b7ec' }}
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </>
  );
};


export const RenderModifyTableTemplate = ({
  isLoading,
  error,
  tableData,
  tableColumns,
  currentRecords,
  searchTerm,
  handleSubmit, // API call handler
  currentPage,
  totalPages,
  paginate
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [newRow, setNewRow] = useState({});
  const [updatedRowIndex, setUpdatedRowIndex] = useState(null);

  // Loading, Error, and Empty Data Handling
  if (isLoading) {
    return (
      <TableLoading />
    );
  }
  if (error) {
    return <p>{error}</p>;
  }
  if (tableData.length === 0) {
    return <p>Nothing Pending for Review</p>;
  }

  // Pagination Logic
  const pageLimit = 3; // Number of visible pages around the current page
  const getVisiblePageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - Math.floor(pageLimit / 2));
    const endPage = Math.min(totalPages, startPage + pageLimit - 1);
    const adjustedStartPage = Math.max(1, endPage - pageLimit + 1);

    for (let i = adjustedStartPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  // Add Row functionality
  const handleAddRow = () => {
    setNewRow({}); // Reset newRow for new input
    setIsEditing(true); // Set editing mode
  };

  // Edit Row functionality
  const handleUpdateRow = (rowIndex) => {
    setUpdatedRowIndex(rowIndex);
    setNewRow(currentRecords[rowIndex]); // Load data for editing
    setIsEditing(true);
  };

  // Delete Row functionality (implement deletion logic)
  const handleDeleteRow = (rowIndex) => {
    // Handle row deletion logic here, for example, remove from currentRecords
    const updatedRecords = currentRecords.filter((_, index) => index !== rowIndex);
    // Assuming handleSubmit handles the new state after deletion
    handleSubmit(updatedRecords);
  };

  // Submit New/Updated Row
  const handleSubmitNewRow = () => {
    handleSubmit(newRow); // Call the API with newRow data
    setIsEditing(false); // Exit editing mode
    setNewRow({}); // Clear newRow
  };

  // Render Table
  return (
    <div>
      <div
        style={{
          maxHeight: 'calc(100vh - 265px)',
          overflowY: 'auto',
          overflowX: 'auto',
          marginTop: '10px',
        }}
      >
        <table
          className={tableClassStyle.className}
          style={tableClassStyle.style}
        >
          <thead
            className="sticky-top"
            style={
              TableHeader1
            }
          >
            <tr>
              {tableColumns.map((key, index) => (
                <th
                  key={index}
                  style={
                    TableHeader1
                  }
                >
                  {key}
                </th>
              ))}
              <th style={TableHeader1}>Actions</th>
            </tr>
          </thead>
          <tbody style={{ border: '1px solid black', padding: '5px' }}>
            {currentRecords.map((item, rowIndex) => (
              <tr
                key={rowIndex}
                style={{
                  boxShadow:
                    rowIndex % 2 === 0
                      ? '2px 2px 4px rgba(0, 0, 0, 0.1)'
                      : '0px 0px 0px rgba(0, 0, 0, 0.2)',
                }}
              >
                {tableColumns.map((key, colIndex) => (
                  <td
                    key={colIndex}
                    style=
                    {
                      tableCellStyle(rowIndex)
                    }
                  >
                    {isEditing && updatedRowIndex === rowIndex ? (
                      <input
                        type="text"
                        value={newRow[tableColumns[colIndex]] || ''}
                        onChange={(e) =>
                          setNewRow({
                            ...newRow,
                            [tableColumns[colIndex]]: e.target.value,
                          })
                        }
                        style={{ width: '100%' }}
                      />
                    ) : (
                      item[key]
                    )}
                  </td>
                ))}
                <td>
                  {isEditing && updatedRowIndex === rowIndex ? (
                    <button

                      style={submit}
                      onClick={handleSubmitNewRow}>Submit</button>
                  ) : (
                    <>
                      <button
                        style={Editcolor}
                        onClick={() => handleUpdateRow(rowIndex)}>Edit</button>
                      <button
                        style={Deletecolor}
                        onClick={() => handleDeleteRow(rowIndex)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {searchTerm.trim() === '' && (
        <div className="d-flex justify-content-center mt-3">
          <button
            type="button"
            className="btn btn-light btn-sm"
            style={
              {
                backgroundColor: '#26b7ec',
                borderColor: 'transparent',
                marginRight: '10px',
                color: 'black',
              }
            }
            onClick={handleAddRow}
          >
            Add Row
          </button>
        </div>
      )}

      <Pagination
        totalPages={totalPages}
        currentPage={currentPage}
        paginate={paginate}
      />
    </div>
  );
};



export const RenderTableTemplate = ({
  isLoading,
  error,
  tableData,
  tableColumns,
  currentRecords,
  searchTerm,
  handleApprove,
  handleReject,
  currentPage,
  totalPages,
  paginate
}) => {
  const flag = new URLSearchParams(window.location.search).get('flag');

  if (isLoading) {
    return (
      <TableLoading />
    );
  }
  if (error) {
    return <p>{error}</p>;
  }
  if (tableData.length === 0) {
    return <p>Nothing Pending for Review</p>;
  }

  const pageLimit = 3; // Number of visible pages around the current page
  const getVisiblePageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - Math.floor(pageLimit / 2));
    const endPage = Math.min(totalPages, startPage + pageLimit - 1);
    const adjustedStartPage = Math.max(1, endPage - pageLimit + 1);

    for (let i = adjustedStartPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };
  const filteredColumns = flag === 'Y'
    ? tableColumns
    : tableColumns.filter(col => col !== 'col_rename' && col !== 'col_active');


  return (
    <div>
      <div
        style={{
          maxHeight: 'calc(100vh - 265px)',
          overflowY: 'auto',
          overflowX: 'auto',
          marginTop: '10px',
        }}
      >
        <table
          className={tableClassStyle.className}
          style={tableClassStyle.style}
        >
          <thead
            className="sticky-top"
            style={TableHeader1}
          >
            <tr>
              {filteredColumns
                .map((key, index) => (
                  <th key={index} style={TableHeader1}>
                    {TableHeader1.aliasNames[key] || key}
                  </th>
                ))}
            </tr>

          </thead>
          <tbody style={tbodyStyles}>
            {currentRecords.map((item, rowIndex) => (
              <tr
                key={rowIndex}
                style={{
                  boxShadow:
                    rowIndex % 2 === 0
                      ? '2px 2px 4px rgba(0, 0, 0, 0.1)'
                      : '0px 0px 0px rgba(0, 0, 0, 0.2)',
                }}
              >
                {filteredColumns.map((key, colIndex) => (
                  <td
                    key={colIndex}
                    style={
                      tableCellStyle3(rowIndex)
                    }
                  >
                    {key === 'col_label'
                      ? toCamelCaseforTableProps(item[key])
                      : key === 'col_key'
                        ? item[key].toLowerCase()
                        : key === 'col_type'
                          ? item[key].toLowerCase()
                          : key === 'col_name'
                            ? item[key].toLowerCase()
                            : item[key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {searchTerm.trim() === '' && (
        <div className="d-flex justify-content-center mt-3">
          <button
            type="button"
            className="btn btn-light btn-sm"
            style={{
              ...Aprrovecolor,
              borderColor: 'transparent',
              marginRight: '10px',
              color: 'black',
            }}
            onClick={handleApprove}
          >
            Approve
          </button>
          <button
            type="button"
            className="btn btn-light btn-sm"
            style={{
              ...Rejectcolor,
              borderColor: 'transparent',
              color: 'white',
              width: '66px',
            }}
            onClick={() => handleReject('reject')}
          >
            Reject
          </button>
        </div>
      )}


      <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />
    </div>
  );
};

export const RDMDEMBDMcheckerRetrieveTable = ({
  isLoading,
  error,
  currentRecords,
  tableData,
  tableColumns,
  totalPages,
  currentPage,
  paginate,
  handleReject,
  handleAccept,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [Updatedcolumns, setUpdatedcolumns] = useState('');

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };


  const handleCheckboxChange = (key) => {
    setUpdatedcolumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    );

  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (isLoading) {
    return (
      <TableLoading />
    );
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (currentRecords.length === 0) {
    return <p>Nothing Pending for Review</p>;
  }

  const hasRecords = tableData.length > 0;
  const hasRejectedRecords = tableData.some(
    (item) =>
      item.rejectedReason === '\\N' ||
      item.rejectedReason === '\N' ||
      item.rejectedReason === 'NULL'
  );

  if (!hasRecords || !hasRejectedRecords) {
    return <p>Nothing Pending for Review</p>;
  }

  const dropdownOptions = [
    { key: 'modified_by', label: 'Modified By' },
    { key: 'modified_dt', label: 'Modified Date' },
  ];

  return (
    <div>
      <div
        style={{
          maxHeight: 'calc(100vh - 265px)',
          overflowY: 'auto',
          overflowX: 'auto',
          marginTop: '10px',
        }}
      >
        <table className={tableClassStyle.className} style={tableClassStyle.style}>
          {hasRejectedRecords && (
            <thead className="sticky-top" style={TableHeader1}>
              <tr>
                {tableColumns.map((key, index) => (
                  !['rowId', 'rejectedReason', 'flag', 'retrievalReason'].includes(key) &&


                  !dropdownOptions.some((option) => option.key === key) && (
                    <th scope="col" key={index} style={TableHeader1}>
                      {key}
                    </th>
                  )
                ))}
                <th scope="col" style={TableHeader1}>
                  Description
                </th>
                {Updatedcolumns.length > 0 &&
                  Updatedcolumns.map((column) => (
                    <th key={column} scope="col" style={TableHeader1}>
                      {dropdownOptions.find((option) => option.key === column)?.label}
                    </th>
                  ))}
                <th scope="col" style={{ position: 'relative' }}>
                  status
                  <div
                    ref={dropdownRef}
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      marginLeft: '10px',
                    }}
                  >
                    <button
                      onClick={toggleDropdown}
                      style={{
                        color: 'black',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                      }}
                    >
                      <i className="bi bi-caret-down-square" style={{ color: 'black' }}></i>

                    </button>

                    {showDropdown && (
                      <div
                        style={{
                          position: 'fixed',
                          top: '151px',
                          right: '10px',
                          backgroundColor: 'white',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                          zIndex: '1000',
                          borderRadius: '4px',
                          minWidth: '150px',
                          color: 'black',
                          padding: '5px',
                        }}
                      >
                        {dropdownOptions.map((option) => (
                          <div
                            key={option.key}
                            style={{
                              display: 'flex',
                              alignItems: 'left',
                              cursor: 'pointer',
                              transition: 'background 0.2s',
                              padding: '1px 5px',
                              fontWeight: 'normal',
                              fontSize: '14px',
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={Updatedcolumns.includes(option.key)}
                              onChange={() => handleCheckboxChange(option.key)}
                              style={{ marginRight: '8px' }}
                              onMouseEnter={(e) => (e.target.style.background = '#f5f5f5')}
                              onMouseLeave={(e) => (e.target.style.background = 'transparent')}


                            />
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </th>
              </tr>
            </thead>
          )}
          <tbody style={tbodyStyles}>
            {currentRecords.map((item, rowIndex) => (
              (item.rejectedReason === '\\N' ||
                item.rejectedReason === '\N' ||
                item.rejectedReason === 'NULL') && (
                <tr
                  key={rowIndex}
                  style={{
                    boxShadow: rowIndex % 2 === 0 ? '2px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 0px 0px rgba(0, 0, 0, 0.2)',
                    border: '1px solid black',
                    padding: '5px',
                    height: '10px',
                    lineHeight: '30px',
                  }}
                >
                  {/* Render non-selected columns */}
                  {Object.keys(item).map((key, colIndex) => (
                    !['rowId', 'rejectedReason', 'flag', 'retrievalReason'].includes(key) &&

                    !dropdownOptions.some((option) => option.key === key) && (
                      <td key={colIndex} style={tableCellStyle(rowIndex)}>
                        {item[key]}
                      </td>
                    )
                  ))}

                  <td style={tableCellStyle(rowIndex)}>
                    Admin has initiated for a Data Retrieval
                  </td>
                  {Updatedcolumns.length > 0 &&
                    Updatedcolumns.map((column) => (
                      <td key={column} style={tableCellStyle(rowIndex)}>
                        {item[column] || 'N/A'}
                      </td>
                    ))}

                  <td style={tableCellStyle(rowIndex)}>
                    <button
                      type="button"
                      className="btn btn-light btn-sm"
                      data-toggle="tooltip"
                      data-placement="Left"
                      title="Click to Accept"
                      style={{
                        marginLeft: '15px',
                        border: 'none',
                        backgroundColor: 'transparent',
                      }}
                      onClick={() => handleReject(item.rowId)}
                    >
                      <link
                        href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                        rel="stylesheet"
                      />
                      <i
                        className="bi bi-check-circle"
                        style={{
                          ...ApporveIcon,
                          marginRight: '10px',
                        }}
                      ></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-light btn-sm"
                      data-toggle="tooltip"
                      data-placement="Left"
                      title="Click to Deny"
                      style={{
                        border: 'none',
                        backgroundColor: 'transparent',
                      }}
                      onClick={() => handleAccept(item.rowId)}
                    >
                      <i
                        className="bi bi-x-circle"
                        style={{
                          ...RejectIcon,
                          marginRight: '5px',

                        }}
                      ></i>
                    </button>
                  </td>
                </tr>
              )
            ))}
          </tbody>
        </table>
      </div>

      <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />
    </div>
  );
};

export const MasterModifyTableRDM = ({
  isLoading, error, currentRecords, tableData,
  filterRejectedRecords, tableColumns, handleInputChange, handleSave,
  handleCancel, handleEdit, handleDeleteClick, editingIndex,
  totalPages, currentPage, paginate
}) => {


  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [Updatedcolumns, setUpdatedcolumns] = useState([]); // Changed to an array

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCheckboxChange = (key) => {
    setUpdatedcolumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    )
  };

  if (isLoading) {
    return <TableLoading />;
  }
  if (error) {
    return <p>{error}</p>;
  }
  if (currentRecords.length === 0) {
    return <p>Nothing Pending for Review</p>;
  }
  const hasRecords = tableData.length > 0;
  if (!hasRecords || !filterRejectedRecords) {
    return <p>Nothing Pending for Review</p>;
  }

  const dropdownOptions = [
    { key: 'created_by', label: 'Created By' },
    { key: 'created_dt', label: 'Created Date' },
    { key: 'modified_by', label: 'Modified By' },
    { key: 'modified_dt', label: 'Modified Date' }
  ];

  return (
    <div>
      <div style={{ maxHeight: 'calc(101vh - 264px)', overflowY: 'auto', overflowX: 'auto', marginTop: '10px' }}>
        <table className={tableClassStyle.className} style={tableClassStyle.style}>
          {filterRejectedRecords && (
            <thead className="sticky-top" style={TableHeader1}>
              <tr>

                {tableColumns.map((key, index) => (
                  !['rowId', 'flag', 'dataModel'].includes(key) &&

                  !dropdownOptions.some((option) => option.key === key) && (
                    (editingIndex === null || key !== 'Rejected_Reason' || key !== 'created_by' || key !== 'modified_dt' || key !== 'created_dt' || key !== 'modified_by' || key !== 'dataModel') &&
                    <th scope="col" key={index} style={TableHeader1}>{key}</th>
                  )
                ))}

                {Updatedcolumns.length > 0 &&
                  Updatedcolumns.map((column) => (
                    <th key={column} scope="col" style={TableHeader1}>
                      {dropdownOptions.find((option) => option.key === column)?.label}
                    </th>
                  ))}

                <th scope="col" style={{ position: 'relative' }}>
                  Actions
                  <div
                    ref={dropdownRef}
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      marginLeft: '10px',
                    }}
                  >
                    <button
                      onClick={toggleDropdown}
                      style={{
                        color: 'black',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                      }}
                    >
                      <i
                        className="bi bi-caret-down-square"
                        style={{ color: 'black' }}
                      ></i>
                    </button>

                    {showDropdown && (
                      <div
                        style={{
                          position: 'fixed',
                          top: '151px',
                          right: '10px',
                          backgroundColor: 'white',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                          zIndex: '1000',
                          borderRadius: '4px',
                          minWidth: '150px',
                          color: 'black',
                          padding: '5px',
                        }}
                      >
                        {dropdownOptions.map((option) => (
                          <div
                            key={option.key}
                            style={{
                              display: 'flex',
                              alignItems: 'left',
                              cursor: 'pointer',
                              transition: 'background 0.2s',
                              padding: '3px 5px',
                              fontWeight: 'normal',
                              fontSize: '14px',
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={Updatedcolumns.includes(option.key)}
                              onChange={() => handleCheckboxChange(option.key)}
                              style={{ marginRight: '8px' }}
                              onMouseEnter={(e) => (e.target.style.background = '#f5f5f5')}
                              onMouseLeave={(e) => (e.target.style.background = 'transparent')}
                            />
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </th>
              </tr>
            </thead>
          )}
          <tbody style={tbodyStyles}>
            {currentRecords.map((item, localRowIndex) => {
              const globalRowIndex = tableData.indexOf(item);
              return (
                (editingIndex === null || editingIndex === globalRowIndex) && (
                  <tr key={localRowIndex} style={{ boxShadow: localRowIndex % 2 === 0 ? '2px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 0px 0px rgba(0, 0, 0, 0.2)', padding: '5px', height: '15px', lineHeight: '25px' }}>
                    {Object.keys(item).map((key, colIndex) => (
                      !['rowId', 'flag', 'dataModel'].includes(key) &&
                      !dropdownOptions.some((option) => option.key === key) && (
                        (editingIndex === null || key !== 'Rejected_Reason' || key !== 'created_by' || key !== 'modified_dt' || key !== 'created_dt' || key !== 'modified_by' || key !== 'dataModel') && (
                          <td key={colIndex} style={

                            tableCellStyle2(localRowIndex)
                          }>
                            {editingIndex === globalRowIndex ? (
                              key === "Rejected_Reason" ||
                                key == 'created_by' ||
                                key == 'modified_dt' ||
                                key == 'created_dt' ||
                                key == 'modified_by' ||
                                key == 'dataModel' ||
                                key === "primaryKeyColumn" ? (
                                item[key]
                              ) : (
                                <input
                                  type="text"
                                  value={item[key]}
                                  onChange={(e) => handleInputChange(e, key, globalRowIndex)}
                                />
                              )
                            ) : (
                              item[key] || ''
                            )}
                          </td>
                        )
                      )
                    ))}
                    {Updatedcolumns.length > 0 &&
                      Updatedcolumns.map((column) => (
                        <td key={column} style={tableCellStyle(localRowIndex)}>
                          {item[column] || 'N/A'}
                        </td>
                      ))}

                    <td style={{ whiteSpace: 'nowrap', padding: '2px', textAlign: 'center' }}>
                      {editingIndex === globalRowIndex ? (
                        <>

                          <button
                            type="button"
                            className="btn btn-light btn-sm"
                            data-toggle="tooltip" data-placement="Left" title="Click to Submit"
                            style={{ ...submit, color: "white", fontSize: '12px', marginRight: '10px', width: '60px', height: '28px' }}
                            onClick={() => handleSave(globalRowIndex)}
                          >
                            Submit
                          </button>

                          <button
                            className="btn btn-secondary btn-sm"

                            data-toggle="tooltip" data-placement="Left" title="Click to Cancel"
                            style={{ color: "white", fontSize: '12px', marginRight: '10px', width: '60px', height: '28px' }}
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>

                          <button
                            type="button"
                            className="btn btn-light btn-sm "
                            data-toggle="tooltip"
                            data-placement="Left"
                            title="Click to Edit"
                            style={{
                              marginLeft: '15px',
                              border: 'none',
                              backgroundColor: 'transparent',
                            }}
                            onClick={() => handleEdit(globalRowIndex)}
                          >
                            <link
                              href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                              rel="stylesheet"
                            />
                            <i
                              className="bi bi-pencil"
                              style={{


                                marginRight: '10px',
                                lineHeight: '10px',
                                ...EditIcon
                              }}
                            ></i>
                          </button>

                          <button
                            type="button"
                            className="btn btn-light btn-sm"
                            data-toggle="tooltip"
                            data-placement="Left"
                            title="Click to Delete"
                            style={{
                              border: 'none',            // No border for the button
                              backgroundColor: 'transparent', // Transparent background for the button
                            }}
                            onClick={() => handleDeleteClick(globalRowIndex)}
                          >
                            <i
                              className="bi bi-trash"
                              style={{
                                ...DeleteIcon,
                                marginRight: '5px',
                                lineHeight: '10px',
                              }}
                            ></i>
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                )
              );
            })}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && editingIndex === null && (
        <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />
      )}
    </div>
  );
};

export const AdminRetrieveTable = (isLoading, error, tableData, currentRecords, selectAll, handleSelectAll, tableColumns, checkedItems, handleCheckboxChange, formatDate, searchTerm, handleRetrieve, totalPages, currentPage, paginate, selectedColumn) => {

  if (isLoading) {
    return <TableLoading />
  }
  if (error) {
    return <p>{error}</p>;
  }
  if (tableData.length === 0) {
    return <p>Nothing Pending for Preview</p>;
  }

  return (
    <div>
      <div style={
        TableStyle
      }>
        <table className={tableClassStyle.className} style={tableClassStyle.style}>
          <thead className='sticky-top' style={TableHeader1}>
            <tr>
              <th scope="col">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
                <span className="ml-2" style={{ marginLeft: '10px', textAlign: 'left' }}>Retrieve</span>
              </th>
              {tableColumns.map((key, index) => (
                !['rowId', 'Rejected_Reason', 'active_yn'].includes(key) &&
                (selectedColumn.includes(key) ||
                  !['created_by', 'created_dt', 'modified_dt', 'modified_by', 'approved_dt', 'approved_by'].includes(key)) && (
                  <th scope="col" style={TableHeader1} key={index}>{key}</th>
                )
              ))}

            </tr>
          </thead>
          <tbody style={
            { border: '1px solid black', padding: '5px' }
          }>
            {currentRecords.map((row, rowIndex) => (
              <tr key={rowIndex} style={
                { boxShadow: rowIndex % 2 === 0 ? '2px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 0px 0px rgba(0, 0, 0, 0.2)' }

              }>
                <td style={
                  { border: '1px solid black', backgroundColor: '#f2f2f2', textAlign: 'left', padding: '5px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <input
                    type="checkbox"
                    checked={checkedItems[row.rowId] || false}
                    onChange={() => handleCheckboxChange(row.rowId)}
                  />
                </td>
                {tableColumns.map((col, colIndex) => (
                  !['rowId', 'Rejected_Reason', 'active_yn'].includes(col) &&
                  (selectedColumn.includes(col) ||
                    !['created_by', 'created_dt', 'modified_dt', 'modified_by', 'approved_dt', 'approved_by'].includes(col)) && (
                    <td style={tbodyStyles} key={colIndex}>
                      {col === 'date' ? formatDate(row[col]) : row[col]}
                    </td>
                  )
                ))}

              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center mt-3">
        <button
          type="button"
          className="btn btn-light btn-sm custom-btn"
          style={{
            ...Retrievecolor,
            borderColor: 'transparent',
            marginRight: '10px',
            color: 'black',
          }}
          onClick={handleRetrieve}
        >
          Retrieve
        </button>
      </div>
      <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />

    </div>
  );
};

export const Hidingconditions = (tableData) => {
  return tableData.some(item =>
    item.rejectedReason !== "Ready for validation. (updated)" &&
    item.rejectedReason !== "\\N" &&
    item.rejectedReason !== "" &&
    item.rejectedReason !== "NULL" &&
    item.rejectedReason !== ""
  );
};

export const RetrieveModifyTableStructure = ({
  isLoading,
  error,
  currentRecords,
  tableData,
  tableColumns,
  totalPages,
  currentPage,
  paginate,
  handleInputChange,
  handleSave,
  handleCancel,
  handleEdit,
  handleDeleteClick,
  editingIndex,
  primaryKeyColumn
}) => {

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [Updatedcolumns, setUpdatedcolumns] = useState([]); // Changed to an array

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (isLoading) {
    return (
      <TableLoading />
    );
  }

  if (isLoading) {
    return <TableLoading />;
  }

  if (error) {
    return <p>{error}</p>; // Show error message
  }

  if (currentRecords.length === 0) {
    return <p>Nothing Pending for Modification</p>;
  }

  const hasRecords = tableData.length > 0;
  const hasRejectedRecords = tableData.some(item =>
    item.dataModel !== "BDM"
  );

  if (!hasRecords || !hasRejectedRecords) {
    return <p>Nothing Pending for Modification</p>;
  }

  const handleCheckboxChange = (key) => {
    setUpdatedcolumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    )
  };

  const dropdownOptions = [
    { key: 'modified_by', label: 'Modified By' },
    { key: 'modified_dt', label: 'Modified Date' },
    { key: 'created_by', label: 'Created By' },
    { key: 'created_dt', label: 'Created Date' },
    { key: 'approved_dt', label: 'Approved Date' },
    { key: 'approved_by', label: 'Approved By' },
  ];

  return (
    <div>
      <div style={{ maxHeight: 'calc(100vh - 265px)', overflowY: 'auto', overflowX: 'auto', marginTop: '10px' }}>
        <table className={tableClassStyle.className} style={tableClassStyle.style}>
          {hasRejectedRecords && (
            <thead className='sticky-top' style={TableHeader1}>
              <tr>

                {tableColumns.map((key, index) => (
                  !['rowId', 'flag', 'dataModel'].includes(key) &&

                  !dropdownOptions.some((option) => option.key === key) && (
                    (editingIndex === null || key !== 'Rejected_Reason' || key !== 'created_by' || key !== 'modified_dt' || key !== 'created_dt' || key !== 'modified_by' || key !== 'approved_dt' || key !== 'approved_by') &&
                    <th scope="col" key={index} style={TableHeader1}>{key}</th>
                  )
                ))}
                {Updatedcolumns.length > 0 &&
                  Updatedcolumns.map((column) => (
                    <th key={column} scope="col" style={TableHeader1}>
                      {dropdownOptions.find((option) => option.key === column)?.label}
                    </th>
                  ))}

                <th scope="col" style={{ position: 'relative' }}>
                  Actions
                  <div
                    ref={dropdownRef}
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      marginLeft: '10px',
                    }}
                  >
                    <button
                      onClick={toggleDropdown}
                      style={{
                        color: 'black',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                      }}
                    >
                      <i
                        className="bi bi-caret-down-square"
                        style={{ color: 'black' }}
                      ></i>
                    </button>
                    {showDropdown && (
                      <div
                        style={{
                          position: 'fixed',
                          top: '151px',
                          right: '10px',
                          backgroundColor: 'white',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                          zIndex: '1000',
                          borderRadius: '4px',
                          minWidth: '150px',
                          color: 'black',
                          padding: '5px',
                        }}
                      >
                        {dropdownOptions.map((option) => (
                          <div
                            key={option.key}
                            style={{
                              display: 'flex',
                              alignItems: 'left',
                              cursor: 'pointer',
                              transition: 'background 0.2s',
                              padding: '3px 5px',
                              fontWeight: 'normal',
                              fontSize: '14px',
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={Updatedcolumns.includes(option.key)}
                              onChange={() => handleCheckboxChange(option.key)}
                              style={{ marginRight: '8px' }}
                              onMouseEnter={(e) => (e.target.style.background = '#f5f5f5')}
                              onMouseLeave={(e) => (e.target.style.background = 'transparent')}
                            />
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </th>
              </tr>
            </thead>
          )}
          <tbody style={tbodyStyles}>
            {currentRecords.map((item, localRowIndex) => {
              const globalRowIndex = tableData.indexOf(item);

              return (
                (editingIndex === null || editingIndex === globalRowIndex) && (
                  <tr key={localRowIndex}
                  >
                    {Object.keys(item).map((key, colIndex) => (
                      !['rowId', 'flag', 'dataModel'].includes(key) &&
                      !dropdownOptions.some((option) => option.key === key) && (
                        (editingIndex === null || key !== 'Rejected_Reason' || key !== 'created_by' || key !== 'modified_dt' || key !== 'created_dt' || key !== 'modified_by' || key !== 'approved_dt' || key !== 'approved_by') &&
                        (
                          <td key={colIndex}

                            style={
                              tableCellStyle(globalRowIndex)
                            }>
                            {editingIndex === globalRowIndex ? (
                              key === "Rejected_Reason" ||
                                key == 'created_by' ||
                                key == 'modified_dt' ||
                                key == 'created_dt' ||
                                key == 'modified_by' ||
                                key == primaryKeyColumn ? (
                                item[key]
                              ) : (
                                <input
                                  type="text"
                                  value={item[key]}
                                  onChange={(e) => handleInputChange(e, key, globalRowIndex)}
                                  readOnly={primaryKeyColumn}
                                />
                              )
                            ) : (
                              item[key] || ''
                            )}
                          </td>
                        )
                      )
                    ))}
                    {Updatedcolumns.length > 0 &&
                      Updatedcolumns.map((column) => (
                        <td key={column} style={tableCellStyle(globalRowIndex)}>
                          {item[column] || 'N/A'}
                        </td>
                      ))}
                    <td style={tableCellStyle(globalRowIndex)} >
                      {editingIndex === globalRowIndex ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-light btn-sm"
                            style={{
                              ...submit,
                              color: "white", fontSize: '12px', marginRight: '10px', width: '60px', height: '28px'
                            }}
                            onClick={() => handleSave(globalRowIndex)}
                          >
                            Submit
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            style={{

                              color: "white", fontSize: '12px', marginRight: '10px', width: '60px', height: '28px',
                            }}
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            type="button"
                            className="btn btn-light btn-sm "
                            data-toggle="tooltip"
                            data-placement="Left"
                            title="Click to Edit"
                            style={{
                              marginLeft: '15px',
                              border: 'none',
                              backgroundColor: 'transparent',
                            }}
                            onClick={() => handleEdit(globalRowIndex)}
                          >
                            <link
                              href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                              rel="stylesheet"
                            />
                            <i
                              className="bi bi-pencil"
                              style={{
                                ...EditIcon,
                                marginRight: '10px',
                                lineHeight: '10px'
                              }}
                            ></i>
                          </button>

                        </>
                      )}
                    </td>
                  </tr>
                )
              );
            })}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && editingIndex === null && (
        <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />
      )}
    </div>
  );
};




export const RetrieveModifyTableStructureBDM = ({
  isLoading,
  error,
  currentRecords,
  tableData,
  tableColumns,
  totalPages,
  currentPage,
  paginate,
  handleInputChange,
  handleSave,
  handleCancel,
  handleEdit,
  handleDeleteClick,
  editingIndex,
  primaryKeyColumn
}) => {

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [Updatedcolumns, setUpdatedcolumns] = useState([]); // Changed to an array

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (isLoading) {
    return (
      <TableLoading />
    );
  }

  if (isLoading) {
    return <TableLoading />;
  }


  if (error) {
    return <p>{error}</p>; // Show error message
  }

  if (currentRecords.length === 0) {
    return <p>Nothing Pending for Modification Current record</p>;
  }

  const hasRecords = tableData.length > 0;
  const hasRejectedRecords = tableData.some(item =>
    item.rejectedReason !== "Ready for validation. (updated)" &&
    item.rejectedReason !== "\\N" &&
    item.rejectedReason !== "" &&
    item.rejectedReason !== "NULL" &&
    item.rejectedReason !== ""
  );

  if (!hasRecords || !hasRejectedRecords) {
    return <p>Nothing Pending for Modification has Records hasRejectedRecords</p>;
  }

  const handleCheckboxChange = (key) => {
    setUpdatedcolumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    )
  };

  const dropdownOptions = [
    { key: 'modified_by', label: 'Modified By' },
    { key: 'modified_dt', label: 'Modified Date' },
    { key: 'created_by', label: 'Created By' },
    { key: 'created_dt', label: 'Created Date' },
    { key: 'approved_dt', label: 'Approved Date' },
    { key: 'approved_by', label: 'Approved By' },
  ];



  return (
    <div>
      <div style={{ maxHeight: 'calc(100vh - 265px)', overflowY: 'auto', overflowX: 'auto', marginTop: '10px' }}>
        <table className={tableClassStyle.className} style={tableClassStyle.style}>
          {hasRejectedRecords && (
            <thead className='sticky-top' style={TableHeader1}>
              <tr>
                {tableColumns.map((key, index) => (
                  !['rowId', 'flag', 'dataModel'].includes(key) &&

                  !dropdownOptions.some((option) => option.key === key) && (
                    (editingIndex === null || key !== 'Rejected_Reason' || key !== 'created_by' || key !== 'modified_dt' || key !== 'created_dt' || key !== 'modified_by' || key !== 'approved_dt' || key !== 'approved_by') &&
                    <th scope="col" key={index} style={TableHeader1}>{key}</th>
                  )
                ))}
                {Updatedcolumns.length > 0 &&
                  Updatedcolumns.map((column) => (
                    <th key={column} scope="col" style={TableHeader1}>
                      {dropdownOptions.find((option) => option.key === column)?.label}
                    </th>
                  ))}

                <th scope="col" style={{ position: 'relative' }}>
                  Actions
                  <div
                    ref={dropdownRef}
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      marginLeft: '10px',
                    }}
                  >
                    <button
                      onClick={toggleDropdown}
                      style={{
                        color: 'black',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                      }}
                    >
                      <i
                        className="bi bi-caret-down-square"
                        style={{ color: 'black' }}
                      ></i>
                    </button>
                    {showDropdown && (
                      <div
                        style={{
                          position: 'fixed',
                          top: '151px',
                          right: '10px',
                          backgroundColor: 'white',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                          zIndex: '1000',
                          borderRadius: '4px',
                          minWidth: '150px',
                          color: 'black',
                          padding: '5px',
                        }}
                      >
                        {dropdownOptions.map((option) => (
                          <div
                            key={option.key}
                            style={{
                              display: 'flex',
                              alignItems: 'left',
                              cursor: 'pointer',
                              transition: 'background 0.2s',
                              padding: '3px 5px',
                              fontWeight: 'normal',
                              fontSize: '14px',
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={Updatedcolumns.includes(option.key)}
                              onChange={() => handleCheckboxChange(option.key)}
                              style={{ marginRight: '8px' }}
                              onMouseEnter={(e) => (e.target.style.background = '#f5f5f5')}
                              onMouseLeave={(e) => (e.target.style.background = 'transparent')}
                            />
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </th>
              </tr>
            </thead>
          )}
          <tbody style={tbodyStyles}>
            {currentRecords.map((item, localRowIndex) => {
              const globalRowIndex = tableData.indexOf(item);

              return (
                (editingIndex === null || editingIndex === globalRowIndex) && (
                  <tr key={localRowIndex}>
                    {Object.keys(item).map((key, colIndex) => {
                      // Check if the column is part of the primaryKeyColumn list
                      const isPrimaryKey = primaryKeyColumn.some(pk => pk.columnName === key);

                      return (
                        !['rowId', 'flag', 'dataModel'].includes(key) &&
                        !dropdownOptions.some((option) => option.key === key) && (
                          (editingIndex === null ||

                            key !== 'created_by' &&
                            key !== 'modified_dt' &&
                            key !== 'created_dt' &&
                            key !== 'modified_by' &&
                            key !== 'approved_dt' &&
                            key !== 'approved_by' &&
                            key !== isPrimaryKey) && (
                            <td key={colIndex} style={tableCellStyle(globalRowIndex)}>
                              {editingIndex === globalRowIndex ? (
                                // If it's a primary key column, make it read-only
                                isPrimaryKey || key === 'Rejected_Reason' ? (
                                  <input
                                    type="text"
                                    value={item[key]}
                                    readOnly
                                    style={{ backgroundColor: '#f0f0f0' }} // Optional: Style to show it's read-only
                                  />
                                ) : (
                                  <input
                                    type="text"
                                    value={item[key]}
                                    onChange={(e) => handleInputChange(e, key, globalRowIndex)}
                                  />
                                )
                              ) : (
                                item[key] || ''
                              )}
                            </td>
                          )
                        )
                      );
                    })}

                    {Updatedcolumns.length > 0 &&
                      Updatedcolumns.map((column) => (
                        <td key={column} style={tableCellStyle(globalRowIndex)}>
                          {item[column] || 'N/A'}
                        </td>
                      ))}

                    <td style={tableCellStyle(globalRowIndex)}>
                      {editingIndex === globalRowIndex ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-light btn-sm"
                            style={{
                              ...submit,
                              color: 'White', fontSize: '12px', marginRight: '10px', width: '60px', height: '28px'
                            }}
                            onClick={() => handleSave(globalRowIndex)}
                          >
                            Submit
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            style={{
                              color: 'white', fontSize: '12px', marginRight: '10px', width: '60px', height: '28px',
                            }}
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            type="button"
                            className="btn btn-light btn-sm "
                            data-toggle="tooltip"
                            data-placement="Left"
                            title="Click to Edit"
                            style={{
                              marginLeft: '15px',
                              border: 'none',
                              backgroundColor: 'transparent',
                            }}
                            onClick={() => handleEdit(globalRowIndex)}
                          >
                            <link
                              href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                              rel="stylesheet"
                            />
                            <i
                              className="bi bi-pencil"
                              style={{
                                ...EditIcon,
                                marginRight: '10px',
                                lineHeight: '10px'
                              }}
                            ></i>
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                )
              );
            })}
          </tbody>

        </table>
      </div>

      {totalPages > 1 && editingIndex === null && (
        <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />
      )}
    </div>
  );
};

export const RetrieveModifyTable = ({
  isLoading,
  error,
  currentRecords,
  tableData,
  tableColumns,
  totalPages,
  currentPage,
  paginate,
  handleInputChange,
  handleSave,
  handleCancel,
  handleEdit,
  handleDeleteClick,
  filteredByRejectedReason,
  editingIndex,
  primaryKeyColumn
}) => {


  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [Updatedcolumns, setUpdatedcolumns] = useState([]); // Changed to an array



  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (isLoading) {
    return (
      <LoadingIcon />
    );
  }

  if (isLoading) {
    return <LoadingIcon />;
  }

  if (error) {
    return <p>{error}</p>; // Show error message
  }

  if (currentRecords.length === 0) {
    return <p>Nothing Pending for Modification</p>;
  }

  const hasRecords = tableData.length > 0;
  const hasRejectedRecords = tableData.some(item =>
    item.Rejected_Reason !== "Ready for validation. (updated)" &&
    item.Rejected_Reason !== "\\N" &&
    item.Rejected_Reason !== "" &&
    item.Rejected_Reason !== "NULL" &&
    item.Rejected_Reason !== ""
    // item.flag !== "R" 
  );

  if (!hasRecords || !hasRejectedRecords) {
    return <p>Nothing Pending for Modification</p>;
  }

  const handleCheckboxChange = (key) => {
    setUpdatedcolumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    )
  };

  const dropdownOptions = [
    { key: 'modified_by', label: 'Modified By' },
    { key: 'modified_dt', label: 'Modified Date' },
    { key: 'created_by', label: 'Created By' },
    { key: 'created_dt', label: 'Created Date' },
    { key: 'approved_dt', label: 'Approved Date' },
    { key: 'approved_by', label: 'Approved By' },
  ];


  return (
    <div>
      <div style={{ maxHeight: 'calc(100vh - 265px)', overflowY: 'auto', overflowX: 'auto', marginTop: '10px' }}>
        <table className={tableClassStyle.className} style={tableClassStyle.style}>
          {hasRejectedRecords && (
            <thead className='sticky-top' style={TableHeader1}>
              <tr>
                {tableColumns.map((key, index) => (
                  !['rowId', 'flag', 'dataModel'].includes(key) &&

                  !dropdownOptions.some((option) => option.key === key) && (
                    (editingIndex === null || key !== 'created_by' || key !== 'modified_dt' || key !== 'created_dt' || key !== 'modified_by' || key !== 'approved_dt' || key !== 'approved_by') &&
                    <th scope="col" key={index} style={TableHeader1}>{key}</th>
                  )
                ))}

                {Updatedcolumns.length > 0 &&
                  Updatedcolumns.map((column) => (
                    <th key={column} scope="col" style={TableHeader1}>
                      {dropdownOptions.find((option) => option.key === column)?.label}
                    </th>
                  ))}

                <th scope="col" style={{ position: 'relative' }}>
                  Actions
                  <div
                    ref={dropdownRef}
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      marginLeft: '10px',
                    }}
                  >
                    <button
                      onClick={toggleDropdown}
                      style={{
                        color: 'black',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                      }}
                    >
                      <i
                        className="bi bi-caret-down-square"
                        style={{ color: 'black' }}
                      ></i>
                    </button>

                    {showDropdown && (
                      <div
                        style={{
                          position: 'fixed',
                          top: '151px',
                          right: '10px',
                          backgroundColor: 'white',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                          zIndex: '1000',
                          borderRadius: '4px',
                          minWidth: '150px',
                          color: 'black',
                          padding: '5px',
                        }}
                      >
                        {dropdownOptions.map((option) => (
                          <div
                            key={option.key}
                            style={{
                              display: 'flex',
                              alignItems: 'left',
                              cursor: 'pointer',
                              transition: 'background 0.2s',
                              padding: '3px 5px',
                              fontWeight: 'normal',
                              fontSize: '14px',
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={Updatedcolumns.includes(option.key)}
                              onChange={() => handleCheckboxChange(option.key)}
                              style={{ marginRight: '8px' }}
                              onMouseEnter={(e) => (e.target.style.background = '#f5f5f5')}
                              onMouseLeave={(e) => (e.target.style.background = 'transparent')}
                            />
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </th>
              </tr>
            </thead>
          )}

          <tbody style={tbodyStyles}>
            {currentRecords.map((item, localRowIndex) => {
              const globalRowIndex = tableData.indexOf(item);

              return (
                (editingIndex === null || editingIndex === globalRowIndex) && (
                  <tr key={localRowIndex}
                  >
                    {Object.keys(item).map((key, colIndex) => (
                      !['rowId', 'flag', 'dataModel'].includes(key) &&
                      !dropdownOptions.some((option) => option.key === key) && (
                        (editingIndex === null || key !== 'created_by' || key !== 'Rejected_Reason' || key !== 'modified_dt' || key !== 'created_dt' || key !== 'modified_by' || key !== 'approved_dt' || key !== 'approved_by') &&
                        (
                          <td key={colIndex}

                            style={
                              tableCellStyle(globalRowIndex)
                            }>
                            {editingIndex === globalRowIndex ? (
                              key == 'Rejected_Reason' ||
                                key == 'created_by' ||
                                key == 'modified_dt' ||
                                key == 'created_dt' ||
                                key == 'modified_by' ||
                                key == 'approved_by' ||
                                key == 'approved_dt' ||
                                key === primaryKeyColumn ? (
                                item[key]
                              ) : (
                                <input
                                  type="text"
                                  value={item[key]}
                                  onChange={(e) => handleInputChange(e, key, globalRowIndex)}
                                />
                              )
                            ) : (
                              item[key] || ''
                            )}
                          </td>
                        )
                      )
                    ))}

                    {Updatedcolumns.length > 0 &&
                      Updatedcolumns.map((column) => (
                        <td key={column} style={tableCellStyle(globalRowIndex)}>
                          {item[column] || 'N/A'}
                        </td>
                      ))}
                    <td style={tableCellStyle(globalRowIndex)} >
                      {editingIndex === globalRowIndex ? (
                        <>
                          <button
                            type="button"
                            className="btn btn-light btn-sm"
                            style={{
                              ...submit,
                              color: "black", fontSize: '12px', marginRight: '10px', width: '60px', height: '28px'
                            }}
                            onClick={() => handleSave(globalRowIndex)}
                          >
                            Submit
                          </button>
                          <button
                            className="btn btn-secondary btn-sm"
                            style={{

                              color: "white", fontSize: '12px', marginRight: '10px', width: '60px', height: '28px',
                            }}
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>

                          <button
                            type="button"
                            className="btn btn-light btn-sm "
                            data-toggle="tooltip"
                            data-placement="Left"
                            title="Click to Edit"
                            style={{
                              marginLeft: '15px',

                              border: 'none',
                              backgroundColor: 'transparent',
                            }}
                            onClick={() => handleEdit(globalRowIndex)}
                          >
                            <link
                              href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
                              rel="stylesheet"
                            />
                            <i
                              className="bi bi-pencil"
                              style={{
                                ...EditIcon,
                                marginRight: '10px',
                                lineHeight: '10px'
                              }}
                            ></i>
                          </button>

                          <button
                            type="button"
                            className="btn btn-light btn-sm"

                            data-toggle="tooltip"
                            data-placement="Left"
                            title="Click to Delete"
                            style={{

                              border: 'none',            // No border for the button
                              backgroundColor: 'transparent', // Transparent background for the button
                            }}
                            onClick={() => handleDeleteClick(globalRowIndex)}
                          >

                            <i
                              className="bi bi-trash"
                              style={{
                                ...DeleteIcon,
                                marginRight: '5px',
                                lineHeight: '10px',


                              }}
                            ></i>
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                )
              );
            })}
          </tbody>

        </table>
      </div>

      {totalPages > 1 && editingIndex === null && (
        <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />
      )}
    </div>
  );
};


export const DEMBDMPreview = ({
  isLoading,
  error,
  tableData,
  currentRecords,
  totalPages,
  currentPage,
  handleEdit,
  paginate
}) => {
  if (isLoading) {
    return (
      <TableLoading />
    );
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (!tableData || tableData.length === 0) {
    return <p>Nothing Pending for Preview</p>;
  }

  const headers = Object.keys(tableData[0]);

  return (
    <div>
      <div style={{ maxHeight: 'calc(100vh - 265px)', overflowY: 'auto', overflowX: 'auto', marginTop: '10px' }}>
        <table className={tableClassStyle.className} style={tableClassStyle.style}>
          <thead className="sticky-top" style={TableHeader1}>
            <tr>
              {headers.map((header, index) => (
                <th key={index} style={TableHeader1}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody style={tbodyStyles}>
            {currentRecords.map((item, rowIndex) => (
              <tr key={rowIndex} style={{ boxShadow: rowIndex % 2 === 0 ? '2px 2px 4px rgba(0, 0, 0, 0.1)' : '0px 0px 0px rgba(0, 0, 0, 0.2)' }}>
                {headers.map((header, columnIndex) => (
                  <td key={columnIndex} style={

                    tableCellStyle(rowIndex)
                  }>{item[header]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center mt-3">
        <button
          type="button"
          className="btn btn-light btn-sm"
          style={{
            ...Aprrovecolor,
            borderColor: 'transparent',
            marginRight: '10px',
            color: 'black',
          }}
          onClick={handleEdit}
        >
          Modify
        </button>
      </div>


      <Pagination totalPages={totalPages} currentPage={currentPage} paginate={paginate} />

    </div>
  );
};

export const toCamelCaseforTableProps = (str) => {
  return str
    .split(' ') // Split by spaces
    .map(word =>
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize first letter, make the rest lowercase
    )
    .join(' '); // Join back with spaces
};



export default filterRejectedRecords;
